/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
};

/** abrechnungsrechte */
export type Abrechnungsrechte = {
  __typename: 'Abrechnungsrechte';
  export: Scalars['Boolean']['output'];
  monatsabschluss: Scalars['Boolean']['output'];
};

export type AbsatzPlanUpdateResult = AbsatzUpdateResultStandortNotFound | AbsatzUpdateResultUpdateError | UmsatzplanungUnkownError | Controlling_Absatz;

export type AbsatzProduktivitaetEinstellungen = {
  __typename: 'AbsatzProduktivitaetEinstellungen';
  absatzVorgabe: AbsatzVorgabe;
  tagebuchAnzeige: TagebuchAnzeige;
  zielProduktivitaet: Scalars['Float']['output'];
};

export type AbsatzProduktivitaetEinstellungenInput = {
  absatzVorgabe: AbsatzVorgabe;
  zielProduktivitaet: Scalars['Float']['input'];
};

/** Fehler wenn der Standort nicht gefunden wurde */
export type AbsatzUpdateResultStandortNotFound = {
  __typename: 'AbsatzUpdateResultStandortNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn der Umsatz nicht geändert werden konnte */
export type AbsatzUpdateResultUpdateError = {
  __typename: 'AbsatzUpdateResultUpdateError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AbsatzVorgabe =
  | 'Mpt'
  | 'Stueck';

export type AbsatzZielUpdateResult = AbsatzUpdateResultStandortNotFound | AbsatzUpdateResultUpdateError | UmsatzplanungUnkownError | Controlling_Absatz;

/** abteilungen */
export type Abteilung = {
  __typename: 'Abteilung';
  id: Scalars['ID']['output'];
  markierung: Markierung;
  name: Scalars['String']['output'];
};

/** abteilung by standort id */
export type AbteilungByStandortId = {
  __typename: 'AbteilungByStandortId';
  abteilung: Array<Abteilung>;
  standortId: Scalars['ID']['output'];
};

/** abteilung error */
export type AbteilungError = {
  __typename: 'AbteilungError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AbteilungResult = AbteilungByStandortId | AbteilungError;

export type Abwesenheiten = {
  __typename: 'Abwesenheiten';
  dauer: Scalars['Float']['output'];
  grund: Abwesenheitsgrund;
  id: Scalars['String']['output'];
};

export type Abwesenheitsantrag = {
  __typename: 'Abwesenheitsantrag';
  bis: Scalars['String']['output'];
  grund: Navigation_Abwesenheitsgrund;
  id: Scalars['String']['output'];
  markierung: Navigation_Markierung;
  mitarbeiter: Navigation_Mitarbeiter2;
  von: Scalars['String']['output'];
};

export type Abwesenheitsgrund =
  | 'ARBEITSUNFALL'
  | 'ARZTBESUCH'
  | 'AUSGLEICHSRUHEZEITENTAG'
  | 'BESCHAEFTIGUNGSVERBOT'
  | 'BEZAHLTERARBEITSFREIERTAG'
  | 'BILDUNG'
  | 'ELTERNZEIT'
  | 'EURENTE'
  | 'FEHLTUNENTSCHULDIGT'
  | 'FEIERTAG'
  | 'FEIERTAGSAUSGLEICH'
  | 'FEIERTAGSAUSGLEICHDYNAMISCH'
  | 'FERIENTAG'
  | 'FREI'
  | 'FREISTELLUNG'
  | 'GUTTAGMINUS'
  | 'GUTTAGPLUS'
  | 'KOMPENSATIONSTAG'
  | 'KRANK'
  | 'KRANKENGELD'
  | 'KRANKESKIND'
  | 'KRANKIMFREI'
  | 'KRANKINKURZARBEIT'
  | 'KRANKOHNELOHNFORTZAHLUNG'
  | 'KUR'
  | 'KURZARBEIT'
  | 'LEHRGANG'
  | 'MILITAERZIVILDIENST'
  | 'MUTTERSCHAFT'
  | 'MUTTERSCHUTZ'
  | 'QUARANTAENE'
  | 'QUARANTAENEOHNELFZ'
  | 'RUHETAG'
  | 'SCHULE'
  | 'SONDERURLAUB'
  | 'UEBERSTUNDENABBAU'
  | 'UNBEZAHLTERFERIENTAG'
  | 'UNBEZAHLTERURLAUB'
  | 'UNFALL'
  | 'URLAUB'
  | 'VATERSCHAFT'
  | 'WIEDEREINGLIEDERUNG'
  | 'WUNSCHFREI';

export type Anrede =
  | 'DIVERS'
  | 'FRAU'
  | 'HERR';

export type AntraegeResult = ArbeitszeitAntraege | ArbeitszeitantragResultAlreadyProcessed | ArbeitszeitantragResultAntragNotFound | ArbeitszeitantragResultArbeitszeitNotFound | ArbeitszeitantragResultManagerNotFound | ArbeitszeitantragResultOtherValidationError;

export type Arbeitnehmertyp =
  | 'AZUBI'
  | 'EHRENAMTLICH'
  | 'KURZ_MIT_LSTK'
  | 'KURZ_OHNE_LSTK'
  | 'MIDIJOB'
  | 'MINIJOB'
  | 'PRAKTIKANT'
  | 'SELBSTSTAENDIG'
  | 'TEILZEIT'
  | 'VOLLZEIT'
  | 'WERKSTUDENT';

/** arbeitsbereich */
export type Arbeitsbereich = {
  __typename: 'Arbeitsbereich';
  abteilungen?: Maybe<Array<Abteilung>>;
  id: Scalars['ID']['output'];
  idStandort: Scalars['ID']['output'];
  markierung: Markierung;
  name: Scalars['String']['output'];
};

/** arbeitsbereich by standort id */
export type ArbeitsbereichByStandortId = {
  __typename: 'ArbeitsbereichByStandortId';
  arbeitsbereiche?: Maybe<Array<Arbeitsbereich>>;
  standortId: Scalars['ID']['output'];
};

/** arbeitsbereich error */
export type ArbeitsbereichError = {
  __typename: 'ArbeitsbereichError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitsbereichResult = ArbeitsbereichByStandortId | ArbeitsbereichError;

export type ArbeitszeitAntraege = {
  __typename: 'ArbeitszeitAntraege';
  antraege: Array<ArbeitszeitAntrag>;
};

export type ArbeitszeitAntrag = {
  __typename: 'ArbeitszeitAntrag';
  aenderungsdatum?: Maybe<Scalars['Date']['output']>;
  antragsistorie: Array<ArbeitszeitAntrag>;
  arbeitsbereich?: Maybe<ArbeitszeitArbeitsbereiche2>;
  arbeitszeitId?: Maybe<Scalars['String']['output']>;
  /** @deprecated beginn2 wurde eingeführt um direkt an der Zeit erkenntlich zu machen ob diese durch den Antrag bearbeitet wird */
  beginn?: Maybe<Scalars['Date']['output']>;
  beginn2: Arbeitszeiten_Antragszeit;
  bemerkungAntragsteller?: Maybe<Scalars['String']['output']>;
  bemerkungVorgesetzter?: Maybe<Scalars['String']['output']>;
  datum?: Maybe<Scalars['Date']['output']>;
  /** @deprecated ende2 wurde eingeführt um direkt an der Zeit erkenntlich zu machen ob diese durch den Antrag bearbeitet wird */
  ende?: Maybe<Scalars['Date']['output']>;
  ende2: Arbeitszeiten_Antragszeit;
  erstellungsdatum?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mitarbeiter?: Maybe<ArbeitszeitenMitarbeiter2>;
  offen?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ArbeitszeitArbeitszeitantragStatus>;
};

export type ArbeitszeitArbeitsbereich = {
  __typename: 'ArbeitszeitArbeitsbereich';
  abteilungen?: Maybe<Array<Abteilung>>;
  id?: Maybe<Scalars['String']['output']>;
  markierung: Markierung;
  name: Scalars['String']['output'];
};

export type ArbeitszeitArbeitsbereichMarkierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type ArbeitszeitArbeitsbereiche2 = {
  __typename: 'ArbeitszeitArbeitsbereiche2';
  abteilungen?: Maybe<Array<ArbeitszeitArbeitsbereiche2Abteilungen>>;
  id: Scalars['String']['output'];
  markierung: ArbeitszeitArbeitsbereichMarkierung;
  name: Scalars['String']['output'];
};

/** abteilungen */
export type ArbeitszeitArbeitsbereiche2Abteilungen = {
  __typename: 'ArbeitszeitArbeitsbereiche2Abteilungen';
  id: Scalars['String']['output'];
  markierung: ArbeitszeitArbeitsbereichMarkierung;
  name: Scalars['String']['output'];
};

export type ArbeitszeitArbeitszeitantragStatus =
  | 'ABGEBROCHEN'
  | 'ABGELAUFEN'
  | 'ABGELEHNT'
  | 'ANFRAGE'
  | 'GELOESCHT'
  | 'GENEHMIGT'
  | 'NEU'
  | 'RUECKFRAGE';

/** ArbeitszeitAuditAenderung */
export type ArbeitszeitAuditAenderung = {
  __typename: 'ArbeitszeitAuditAenderung';
  attribut?: Maybe<ArbeitszeitAuditAenderungsAttribut>;
  nachher?: Maybe<Scalars['String']['output']>;
  vorher?: Maybe<Scalars['String']['output']>;
};

/** Enum for auditAenderungsAttribut */
export type ArbeitszeitAuditAenderungsAttribut =
  | 'ARBEITSBEREICH'
  | 'ART'
  | 'BEGINN'
  | 'BEMERKUNG'
  | 'BETRAG'
  | 'BEZAHLT'
  | 'DATUM'
  | 'DAUER'
  | 'ENDE'
  | 'ERSTELLUNGSDATUM'
  | 'GEHEN'
  | 'KOMMEN'
  | 'MITARBEITER'
  | 'PAUSE'
  | 'STUNDENLOHN';

export type ArbeitszeitAuditAenderungsTyp =
  | 'GELOESCHT'
  | 'NEUES_OBJEKT'
  | 'VERAENDERUNG';

/** ArbeitszeitAuditManager */
export type ArbeitszeitAuditManager = {
  __typename: 'ArbeitszeitAuditManager';
  email?: Maybe<Scalars['String']['output']>;
  nachname?: Maybe<Scalars['String']['output']>;
  vorname?: Maybe<Scalars['String']['output']>;
};

/** Fehler wenn Ende vor Beginn ist */
export type ArbeitszeitCreateEndeVorBeginn = {
  __typename: 'ArbeitszeitCreateEndeVorBeginn';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Manager keinen Zugriff zum Arbeitsbereich hat */
export type ArbeitszeitCreateManagerHasNoAccessToArbeitsbereich = {
  __typename: 'ArbeitszeitCreateManagerHasNoAccessToArbeitsbereich';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Manager nicht gefunden wurde */
export type ArbeitszeitCreateManagerNotFound = {
  __typename: 'ArbeitszeitCreateManagerNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Werte fehlen */
export type ArbeitszeitCreateMissingValues = {
  __typename: 'ArbeitszeitCreateMissingValues';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Monat bereits abgeschlossen ist */
export type ArbeitszeitCreateMonatAbgeschlossen = {
  __typename: 'ArbeitszeitCreateMonatAbgeschlossen';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn andere Validierungsfehler aufgetreten sind */
export type ArbeitszeitCreateOtherValidationError = {
  __typename: 'ArbeitszeitCreateOtherValidationError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitCreateResult = ArbeitszeitCreateEndeVorBeginn | ArbeitszeitCreateManagerHasNoAccessToArbeitsbereich | ArbeitszeitCreateManagerNotFound | ArbeitszeitCreateMissingValues | ArbeitszeitCreateMonatAbgeschlossen | ArbeitszeitCreateOtherValidationError | Arbeitszeiten | ManagerHasRoleArbeitszeitNurHeuteBearbeiten | UnknownError;

/** Fehler wenn Manager keinen Zugriff zum Arbeitsbereich hat */
export type ArbeitszeitDeleteManagerHasNoAccessToArbeitsbereich = {
  __typename: 'ArbeitszeitDeleteManagerHasNoAccessToArbeitsbereich';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitDeleteResult = ArbeitszeitDeleteManagerHasNoAccessToArbeitsbereich | ArbeitszeitManagerNotFound | ArbeitszeitMonatAbgeschlossen | ArbeitszeitNotFound | Arbeitszeiten | ManagerHasRoleArbeitszeitNurHeuteBearbeiten | UnknownError;

/** Arbeitszeiten Fehler */
export type ArbeitszeitError = {
  __typename: 'ArbeitszeitError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitKonflikte = {
  __typename: 'ArbeitszeitKonflikte';
  id?: Maybe<Scalars['String']['output']>;
  konflikt: Scalars['String']['output'];
};

/** Fehler wenn Manager nicht gefunden wurde */
export type ArbeitszeitManagerNotFound = {
  __typename: 'ArbeitszeitManagerNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitManyCreateResult = {
  __typename: 'ArbeitszeitManyCreateResult';
  input?: Maybe<CreateArbeitszeitenBulkReturn>;
  result?: Maybe<ArbeitszeitCreateResult>;
};

export type ArbeitszeitMitarbeiter = {
  __typename: 'ArbeitszeitMitarbeiter';
  bildUrl?: Maybe<Scalars['String']['output']>;
  extern: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

/** Fehler wenn Monat abgeschlossen ist */
export type ArbeitszeitMonatAbgeschlossen = {
  __typename: 'ArbeitszeitMonatAbgeschlossen';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Arbeitszeit nicht gefunden wurde */
export type ArbeitszeitNotFound = {
  __typename: 'ArbeitszeitNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitPuenktlichkeit = {
  __typename: 'ArbeitszeitPuenktlichkeit';
  abweichungBeginn?: Maybe<Scalars['Int']['output']>;
  abweichungEnde?: Maybe<Scalars['Int']['output']>;
};

export type ArbeitszeitRechtshinweise = {
  __typename: 'ArbeitszeitRechtshinweise';
  art: Scalars['String']['output'];
  backgroundcolor: BackgroundColor;
  name: Scalars['String']['output'];
};

export type ArbeitszeitTermineWiederholung =
  | 'JAEHRLICH'
  | 'MONATLICH'
  | 'OHNE'
  | 'TAEGLICH'
  | 'WOECHENTLICH';

/** Fehler wenn Arbeitsbereich nicht gefunden wurde */
export type ArbeitszeitUpdateArbeitsbereichNotFound = {
  __typename: 'ArbeitszeitUpdateArbeitsbereichNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Arbeitszeit nicht gefunden wurde */
export type ArbeitszeitUpdateArbeitszeitNotFound = {
  __typename: 'ArbeitszeitUpdateArbeitszeitNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Beginn vor Ende liegt */
export type ArbeitszeitUpdateBeginnVorEnde = {
  __typename: 'ArbeitszeitUpdateBeginnVorEnde';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn kein Arbeitsbereich übergeben wurde */
export type ArbeitszeitUpdateIdArbeitsbereichNull = {
  __typename: 'ArbeitszeitUpdateIdArbeitsbereichNull';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Pause-Dauer ungültig ist */
export type ArbeitszeitUpdateInvalidPauseDauer = {
  __typename: 'ArbeitszeitUpdateInvalidPauseDauer';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Manager keinen Zugriff auf Arbeitsbereich hat */
export type ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich = {
  __typename: 'ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Manager nicht gefunden wurde */
export type ArbeitszeitUpdateManagerNotFound = {
  __typename: 'ArbeitszeitUpdateManagerNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn Monat bereits abgeschlossen ist */
export type ArbeitszeitUpdateMonatAbgeschlossen = {
  __typename: 'ArbeitszeitUpdateMonatAbgeschlossen';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler bei anderen Validierungsfehlern */
export type ArbeitszeitUpdateOtherValidationError = {
  __typename: 'ArbeitszeitUpdateOtherValidationError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitUpdateResult = ArbeitszeitUpdateArbeitsbereichNotFound | ArbeitszeitUpdateArbeitszeitNotFound | ArbeitszeitUpdateBeginnVorEnde | ArbeitszeitUpdateIdArbeitsbereichNull | ArbeitszeitUpdateInvalidPauseDauer | ArbeitszeitUpdateManagerHasNoAccessToArbeitsbereich | ArbeitszeitUpdateManagerNotFound | ArbeitszeitUpdateMonatAbgeschlossen | ArbeitszeitUpdateOtherValidationError | ArbeitszeitUpdateStaleState | Arbeitszeiten | UnknownError;

/** Fehler bei veralteten Daten */
export type ArbeitszeitUpdateStaleState = {
  __typename: 'ArbeitszeitUpdateStaleState';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Der Antrag wurde erfolgreich abgelehnt. */
export type ArbeitszeitantragAblehnen = {
  __typename: 'ArbeitszeitantragAblehnen';
  bemerkungVorgesetzter?: Maybe<Scalars['String']['output']>;
  idAntrag?: Maybe<Scalars['String']['output']>;
};

/** Ein Fehler ist beim Ablehnen des Antrags aufgetreten. */
export type ArbeitszeitantragAblehnenError = {
  __typename: 'ArbeitszeitantragAblehnenError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitantragAblehnenInput = {
  bemerkungVorgesetzter?: InputMaybe<Scalars['String']['input']>;
  idAntrag: Scalars['String']['input'];
  idManagerVorgesetzter: Scalars['String']['input'];
};

export type ArbeitszeitantragAblehnenResult = ArbeitszeitantragAblehnen | ArbeitszeitantragAblehnenError;

/** Der Antrag wurde erfolgreich genehmigt. */
export type ArbeitszeitantragGenehmigen = {
  __typename: 'ArbeitszeitantragGenehmigen';
  bemerkungVorgesetzter?: Maybe<Scalars['String']['output']>;
  idAntrag?: Maybe<Scalars['String']['output']>;
};

/** Ein Fehler ist beim Genehmigen des Antrags aufgetreten. */
export type ArbeitszeitantragGenehmigenError = {
  __typename: 'ArbeitszeitantragGenehmigenError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ArbeitszeitantragGenehmigenInput = {
  bemerkungVorgesetzter?: InputMaybe<Scalars['String']['input']>;
  idAntrag: Scalars['String']['input'];
  idManagerVorgesetzter: Scalars['String']['input'];
};

export type ArbeitszeitantragGenehmigenResult = ArbeitszeitantragGenehmigen | ArbeitszeitantragGenehmigenError;

/** Der Antrag wurde bereits bearbeitet. */
export type ArbeitszeitantragResultAlreadyProcessed = {
  __typename: 'ArbeitszeitantragResultAlreadyProcessed';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Der Antrag der Arbeitszeitänderung konnte nicht gefunden werden. */
export type ArbeitszeitantragResultAntragNotFound = {
  __typename: 'ArbeitszeitantragResultAntragNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Die zu ändernde Arbeitszeit konnte nicht gefunden werden. */
export type ArbeitszeitantragResultArbeitszeitNotFound = {
  __typename: 'ArbeitszeitantragResultArbeitszeitNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Der Benutzer konnte nicht gefunden werden. */
export type ArbeitszeitantragResultManagerNotFound = {
  __typename: 'ArbeitszeitantragResultManagerNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Ein Validierungsfehler ist aufgetreten. */
export type ArbeitszeitantragResultOtherValidationError = {
  __typename: 'ArbeitszeitantragResultOtherValidationError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Arbeitszeiten = {
  __typename: 'Arbeitszeiten';
  abwesenheit?: Maybe<Abwesenheiten>;
  aenderungsdatum?: Maybe<Scalars['Date']['output']>;
  antraege?: Maybe<Array<ArbeitszeitAntrag>>;
  arbeitsbereich: ArbeitszeitArbeitsbereich;
  audit?: Maybe<Array<Maybe<AuditResult>>>;
  beginn?: Maybe<Scalars['Date']['output']>;
  beginn2?: Maybe<Zeitstempel>;
  /** Die Bemerkung zur Arbeitszeit hat maximal 250 Zeichen. */
  bemerkung?: Maybe<Scalars['String']['output']>;
  datum: Scalars['Date']['output'];
  dauer?: Maybe<Scalars['Int']['output']>;
  dienstgaenge: Array<Arbeitszeiten_Pausen>;
  ende?: Maybe<Scalars['Date']['output']>;
  ende2?: Maybe<Zeitstempel>;
  geaendertVon?: Maybe<Scalars['String']['output']>;
  gehen?: Maybe<Scalars['Date']['output']>;
  gehen2?: Maybe<Zeitstempel>;
  id?: Maybe<Scalars['String']['output']>;
  kommen?: Maybe<Scalars['Date']['output']>;
  kommen2?: Maybe<Zeitstempel>;
  konflikte: Array<ArbeitszeitKonflikte>;
  mitarbeiter: ArbeitszeitMitarbeiter;
  pausen: Array<Arbeitszeiten_Pausen>;
  pauseneinstellung?: Maybe<ArbeitszeitenPauseneinstellung>;
  puenktlichkeit?: Maybe<ArbeitszeitPuenktlichkeit>;
  rechtshinweise: Array<ArbeitszeitRechtshinweise>;
  standortId?: Maybe<Scalars['String']['output']>;
  termin?: Maybe<Arbeitszeiten_Termine>;
  zuschlaege: Array<Arbeitszeiten_Zuschlaege>;
};

export type ArbeitszeitenByDatum = {
  __typename: 'ArbeitszeitenByDatum';
  arbeitszeiten: Array<Arbeitszeiten>;
  datum: Scalars['Date']['output'];
};

export type ArbeitszeitenDienstplanuebernahmen = {
  __typename: 'ArbeitszeitenDienstplanuebernahmen';
  arbeitsbereich: ArbeitszeitArbeitsbereiche2;
  beginn: Scalars['Date']['output'];
  dauer: Scalars['Int']['output'];
  ende?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  ignoriert: Scalars['Boolean']['output'];
  mitarbeiter: ArbeitszeitenMitarbeiter2;
  pause: Scalars['Int']['output'];
  schichtId: Scalars['String']['output'];
  termin?: Maybe<Arbeitszeiten_Termine>;
};

export type ArbeitszeitenMitarbeiter2 = {
  __typename: 'ArbeitszeitenMitarbeiter2';
  bildUrl?: Maybe<Scalars['String']['output']>;
  extern: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type ArbeitszeitenPausenInput = {
  beginn?: InputMaybe<Scalars['String']['input']>;
  bezahlt?: InputMaybe<Scalars['Boolean']['input']>;
  dauer?: InputMaybe<Scalars['Int']['input']>;
  ende?: InputMaybe<Scalars['String']['input']>;
  idPause?: InputMaybe<Scalars['String']['input']>;
  pausenart: ArbeitszeitenPausenartInput;
};

export type ArbeitszeitenPausenart =
  | 'Automatisch'
  | 'Dienstgang'
  | 'Gesetzlich'
  | 'Gestempelt'
  | 'Manuell'
  | 'Rauchen'
  | 'Schicht';

export type ArbeitszeitenPausenartInput =
  | 'AUTOMATISCH'
  | 'DIENSTGANG'
  | 'GESETZLICH'
  | 'GESTEMPELT'
  | 'MANUELL'
  | 'RAUCHEN'
  | 'SCHICHT';

export type ArbeitszeitenPauseneinstellung =
  | 'AUTOMATISCH'
  | 'GESETZLICH'
  | 'OHNE';

export type ArbeitszeitenResult = ArbeitszeitError | ArbeitszeitenByDatum;

export type Arbeitszeiten_AbwesenenheitNotFound = Arbeitszeiten_Error & {
  __typename: 'Arbeitszeiten_AbwesenenheitNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Arbeitszeiten_AbwesenheitMutationResponse = {
  __typename: 'Arbeitszeiten_AbwesenheitMutationResponse';
  abwesenheit?: Maybe<Arbeitszeiten_Abwesenheiten>;
  error?: Maybe<Arbeitszeiten_Error>;
};

export type Arbeitszeiten_Abwesenheiten = {
  __typename: 'Arbeitszeiten_Abwesenheiten';
  id: Scalars['String']['output'];
};

export type Arbeitszeiten_ArbeitszeitNotFound = Arbeitszeiten_Error & {
  __typename: 'Arbeitszeiten_ArbeitszeitNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Arbeitszeiten_Error = {
  message: Scalars['String']['output'];
};

export type Arbeitszeiten_GenericError = Arbeitszeiten_Error & {
  __typename: 'Arbeitszeiten_GenericError';
  message: Scalars['String']['output'];
};

export type Arbeitszeiten_MonatAbgeschlossen = Arbeitszeiten_Error & {
  __typename: 'Arbeitszeiten_MonatAbgeschlossen';
  message: Scalars['String']['output'];
};

export type Arbeitszeiten_TerminMutationResponse = {
  __typename: 'Arbeitszeiten_TerminMutationResponse';
  error?: Maybe<Arbeitszeiten_Error>;
  termin?: Maybe<Arbeitszeiten_Termine>;
};

/** arbeitszeitrechte */
export type Arbeitszeitrechte = {
  __typename: 'Arbeitszeitrechte';
  alleTage: Scalars['Boolean']['output'];
  bearbeiten: Scalars['Boolean']['output'];
  erlaubt: Scalars['Boolean']['output'];
  geldbetraegeAnzeigen: Scalars['Boolean']['output'];
  nurHeute: Scalars['Boolean']['output'];
};

/** ArbeitszeitAudit */
export type Audit = {
  __typename: 'Audit';
  aenderungen?: Maybe<Array<ArbeitszeitAuditAenderung>>;
  aenderungsTyp?: Maybe<ArbeitszeitAuditAenderungsTyp>;
  aenderungsdatum?: Maybe<Scalars['String']['output']>;
  geaendertVon?: Maybe<Scalars['String']['output']>;
  geaendertVonEmail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manager?: Maybe<ArbeitszeitAuditManager>;
  typ?: Maybe<Scalars['String']['output']>;
};

/** audit error */
export type AuditError = {
  __typename: 'AuditError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AuditResult = Audit | AuditError;

/** auswertungsrechte */
export type Auswertungsrechte = {
  __typename: 'Auswertungsrechte';
  arbeitszeit: Scalars['Boolean']['output'];
  dienstplan: Scalars['Boolean']['output'];
  personal: Scalars['Boolean']['output'];
};

export type Auszahlungsgrenze = {
  monatssollBetrag?: InputMaybe<Scalars['Float']['input']>;
  monatssollZeit?: InputMaybe<Scalars['Float']['input']>;
};

export type BackgroundColor =
  | 'Fatal'
  | 'Info'
  | 'Warnung';

export type Banner = {
  __typename: 'Banner';
  aenderungsdatum: Scalars['String']['output'];
  beschreibung: Scalars['String']['output'];
  idStandort: Scalars['String']['output'];
};

export type Controlling = {
  __typename: 'Controlling';
  absatzZiel: Controlling_AbsatzZiel;
  einstellungen?: Maybe<TagebuchEinstellungen>;
  planwerte: Array<Controlling_Planwert>;
  sollstunden: Sollstunden;
  standortId: Scalars['String']['output'];
  tagebuchEintrag: Array<TagebuchEintrag>;
  umsatzZiel: UmsatzZiel;
};


export type ControllingAbsatzZielArgs = {
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
};


export type ControllingPlanwerteArgs = {
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
};


export type ControllingSollstundenArgs = {
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
};


export type ControllingTagebuchEintragArgs = {
  TemperaturEinheit?: InputMaybe<TemperaturEinheit>;
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
};


export type ControllingUmsatzZielArgs = {
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
};

export type CreateArbeitszeitenBulkInput = {
  arbeitsbereichId: Scalars['String']['input'];
  beginn?: InputMaybe<Scalars['String']['input']>;
  datum: Scalars['Date']['input'];
  ende?: InputMaybe<Scalars['String']['input']>;
  mitarbeiterId: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
  terminId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArbeitszeitenBulkReturn = {
  __typename: 'CreateArbeitszeitenBulkReturn';
  arbeitsbereichId: Scalars['String']['output'];
  beginn?: Maybe<Scalars['String']['output']>;
  datum: Scalars['String']['output'];
  ende?: Maybe<Scalars['String']['output']>;
  mitarbeiterId: Scalars['String']['output'];
  standortId: Scalars['String']['output'];
};

export type CreateArbeitszeitenInput2 = {
  arbeitsbereichId?: InputMaybe<Scalars['String']['input']>;
  beginn?: InputMaybe<Scalars['String']['input']>;
  ende?: InputMaybe<Scalars['String']['input']>;
  terminId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMitarbeiterInputResolver = {
  abwesenheiten: MitarbeiterAbwesenheiten;
  allgemein: MitarbeiterAllgemein;
  arbeitsverhaeltnis: MitarbeiterArbeitsverhaeltnisResolver;
  bezahlung: MitarbeiterBezahlung;
  mitarbeiterArbeitszeit: MitarbeiterArbeitszeit;
  personalFragebogen?: InputMaybe<MitarbeiterPersonalfragebogen>;
  personalZugang?: InputMaybe<MitarbeiterPersonalzugang>;
  ueberstundenBehandlung: MitarbeiterCreateUeberstundenBehandlung;
};

export type CreateOrUpdateAbsatzPlan = {
  datum: Scalars['String']['input'];
  plan?: InputMaybe<Scalars['Int']['input']>;
  produktivitaet?: InputMaybe<Scalars['Float']['input']>;
  standortId: Scalars['String']['input'];
};

export type CreateOrUpdateAbsatzziel = {
  absatzziel?: InputMaybe<Scalars['Int']['input']>;
  absatzzielProduktivitaet?: InputMaybe<Scalars['Float']['input']>;
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
  standortId: Scalars['String']['input'];
};

export type CreateOrUpdateInterneNotiz = {
  datum: Scalars['String']['input'];
  interneNotiz: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};

export type CreateOrUpdateUmsatzPlan = {
  datum: Scalars['String']['input'];
  plan?: InputMaybe<MoneyInput>;
  produktivitaet?: InputMaybe<MoneyInput>;
  standortId: Scalars['String']['input'];
};

export type CreateOrUpdateUmsatzziel = {
  jahr: Scalars['Int']['input'];
  monat: Scalars['Int']['input'];
  standortId: Scalars['String']['input'];
  umsatzziel?: InputMaybe<MoneyInput>;
  umsatzzielProduktivitaet?: InputMaybe<MoneyInput>;
};

export type Currency =
  | 'CHF'
  | 'EUR';

export type DatePickerToDo = {
  __typename: 'DatePickerToDo';
  date: Scalars['Date']['output'];
  hasOpenToDos: Scalars['Boolean']['output'];
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

/** dienstplanrechte */
export type Dienstplanrechte = {
  __typename: 'Dienstplanrechte';
  bearbeiten: Scalars['Boolean']['output'];
  erlaubt: Scalars['Boolean']['output'];
  freigabe: Scalars['Boolean']['output'];
  mitarbeiterEinteilen: Scalars['Boolean']['output'];
  schichtvorlagen: Scalars['Boolean']['output'];
};

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Feiertag = {
  __typename: 'Feiertag';
  datum: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FindingsUnion = Mitarbeiter_MitarbeiterEmailCheckFindingBlacklist | Mitarbeiter_MitarbeiterEmailCheckFindingInvalidFormat | Mitarbeiter_MitarbeiterEmailCheckFindingTooLong | Mitarbeiter_MitarbeiterEmailCheckFindingUnknown;

export type InterneNotiz = {
  __typename: 'InterneNotiz';
  datum?: Maybe<Scalars['String']['output']>;
  interneNotiz?: Maybe<Scalars['String']['output']>;
};

export type JahrMonat = {
  __typename: 'JahrMonat';
  jahr: Scalars['Int']['output'];
  monat: Scalars['Int']['output'];
};

export type Lohnabrechnungseinstellungen = {
  __typename: 'Lohnabrechnungseinstellungen';
  beraternummer?: Maybe<Scalars['String']['output']>;
  lohnabrechnungsart?: Maybe<Standort_Lohnabrechnungsart>;
  mandantennummer?: Maybe<Scalars['String']['output']>;
};

/** manager  */
export type Manager = {
  __typename: 'Manager';
  aenderungsdatum: Scalars['Date']['output'];
  creationDate: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  erstellungsdatum: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  idStandort: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  managerrechte: Managerrechte;
  nachname: Scalars['String']['output'];
  settings: ManagerSettings;
  standorte: Array<Standort>;
  vorname: Scalars['String']['output'];
};

/** termine_managerDesignSettings */
export type ManagerDesignSettings = {
  __typename: 'ManagerDesignSettings';
  seitenImV2Design?: Maybe<Array<Scalars['String']['output']>>;
};

/** manager error */
export type ManagerError = {
  __typename: 'ManagerError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn der Manager nur am aktuellen Tag Arbeitszeiten bearbeiten darf und versucht Arbeitszeiten aus der Vergangenheit zu bearbeiten */
export type ManagerHasRoleArbeitszeitNurHeuteBearbeiten = {
  __typename: 'ManagerHasRoleArbeitszeitNurHeuteBearbeiten';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ManagerResult = Manager | ManagerError;

/** manager_ManagerSettings */
export type ManagerSettings = {
  __typename: 'ManagerSettings';
  arbeitszeitenDesign?: Maybe<Scalars['String']['output']>;
};

export type ManagerSettingsResult = ManagerSettings | Manager_ManagerSettingsError;

export type Manager_Error = {
  message: Scalars['String']['output'];
};

export type Manager_GenericError = Manager_Error & {
  __typename: 'Manager_GenericError';
  message: Scalars['String']['output'];
};

export type Manager_ManagerNotFound = Manager_Error & {
  __typename: 'Manager_ManagerNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Manager_NewsItemNotFound = Manager_Error & {
  __typename: 'Manager_NewsItemNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** managerrechte */
export type Managerrechte = {
  __typename: 'Managerrechte';
  abrechnung: Abrechnungsrechte;
  admin: Scalars['Boolean']['output'];
  arbeitszeit: Arbeitszeitrechte;
  auswertung: Auswertungsrechte;
  dienstplan: Dienstplanrechte;
  einstellungen: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  kalender: Scalars['Boolean']['output'];
  konflikte: Scalars['Boolean']['output'];
  mitarbeiter: Mitarbeiterrechte;
  neuigkeiten: Scalars['Boolean']['output'];
  statusmails: Scalars['Boolean']['output'];
  tagebuch: Scalars['Boolean']['output'];
  termine: Scalars['Boolean']['output'];
};

export type Markierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Mitarbeiter = {
  __typename: 'Mitarbeiter';
  arbeitsbereich?: Maybe<MitarbeiterArbeitsbereich>;
  bildUrl?: Maybe<Scalars['String']['output']>;
  extern: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type MitarbeiterAbwesenheiten = {
  abwesenheitszeitBegrenzen?: InputMaybe<Scalars['Boolean']['input']>;
  dynamischeAbwesenheit?: InputMaybe<MitarbeiterCreateDynamischeAbwesenheit>;
  festeAbwesenheit?: InputMaybe<Scalars['Float']['input']>;
  jahresurlaub: Scalars['Float']['input'];
};

export type MitarbeiterAllgemein = {
  anrede: Anrede;
  email?: InputMaybe<Scalars['String']['input']>;
  idArbeitsbereich: Scalars['ID']['input'];
  nachname: Scalars['String']['input'];
  vorname: Scalars['String']['input'];
};

export type MitarbeiterArbeitsbereich = {
  __typename: 'MitarbeiterArbeitsbereich';
  abteilungen?: Maybe<Array<Abteilung>>;
  id: Scalars['String']['output'];
  markierung: Markierung;
  name: Scalars['String']['output'];
};

export type MitarbeiterArbeitsverhaeltnisResolver = {
  arbeitnehmertyp: Arbeitnehmertyp;
  befristung?: InputMaybe<MitarbeiterCreateBefristung>;
  eintrittsdatum: Scalars['DateTime']['input'];
  personalnummer?: InputMaybe<Scalars['String']['input']>;
};

export type MitarbeiterArbeitszeit = {
  tagessoll: Scalars['Float']['input'];
  wochenarbeitstage: MitarbeiterCreateWochenarbeitstage;
  wochensoll: Scalars['Float']['input'];
};

export type MitarbeiterBezahlung = {
  bezahlungNach: MitarbeiterCreateBezahlungNach;
  gehalt?: InputMaybe<Scalars['Float']['input']>;
  idZuschlagsgruppe?: InputMaybe<Scalars['String']['input']>;
  pauschalerZuschlag?: InputMaybe<Scalars['Float']['input']>;
  stundenlohn: Scalars['Float']['input'];
};

/** mitarbeiter by standort id */
export type MitarbeiterByStandortId = {
  __typename: 'MitarbeiterByStandortId';
  mitarbeiter?: Maybe<Array<Mitarbeiter>>;
  standortId: Scalars['ID']['output'];
};

export type MitarbeiterCreateBefristung = {
  austrittsdatum: Scalars['Date']['input'];
};

export type MitarbeiterCreateBerechnung =
  | 'DURCHSCHNITTLICH'
  | 'EXACT';

export type MitarbeiterCreateBerechnungZeitraum =
  | 'PRO_MONAT'
  | 'PRO_WOCHE';

export type MitarbeiterCreateBezahlungNach =
  | 'FixGehalt'
  | 'Stunden';

export type MitarbeiterCreateDynamischeAbwesenheit =
  | 'TAGESDURCHSCHNITT'
  | 'WOCHEN_DURCHSCHNITT'
  | 'ZWOELF_MONATSDURCHSCHNITT';

export type MitarbeiterCreateFreigaben =
  | 'ARBEITSZEITEN'
  | 'DIENSTPLAN'
  | 'KONTAKTE'
  | 'PERSONALFRAGEBOGEN'
  | 'TERMINE'
  | 'URLAUBSKONTO'
  | 'VORHANDEN'
  | 'ZEITERFASSUNG';

export type MitarbeiterCreateUeberstundenBehandlung = {
  auszahlungsgrenze?: InputMaybe<Auszahlungsgrenze>;
  planSoll?: InputMaybe<Plansoll>;
  ueberstunden?: InputMaybe<Ueberstunden>;
};

export type MitarbeiterCreateWochenarbeitstage = {
  arbeitstage: Array<DayOfWeek>;
};

export type MitarbeiterError = {
  __typename: 'MitarbeiterError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MitarbeiterFreigaben = {
  freigaben: MitarbeiterCreateFreigaben;
};

export type MitarbeiterPersonalfragebogen = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type MitarbeiterPersonalzugang = {
  freigaben: Array<MitarbeiterFreigaben>;
};

export type MitarbeiterResult = MitarbeiterByStandortId | MitarbeiterError;

export type Mitarbeiter_FristenErinnerungen = {
  __typename: 'Mitarbeiter_FristenErinnerungen';
  erinnernAm: Scalars['Date']['output'];
  gelesen: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  managerId: Scalars['String']['output'];
};

export type Mitarbeiter_MitarbeiterFristenCreateResponse = {
  __typename: 'Mitarbeiter_MitarbeiterFristenCreateResponse';
  generalError?: Maybe<Mitarbeiter_MitarbeiterGeneralError>;
  result?: Maybe<Array<Mitarbeiter_MitarbeiterFristenCreateResult>>;
};

export type Mitarbeiter_MitarbeiterFristenCreateResult = {
  __typename: 'Mitarbeiter_MitarbeiterFristenCreateResult';
  failure?: Maybe<Mitarbeiter_MitarbeiterFristenError>;
  success?: Maybe<Mitarbeiter_Frist>;
};

export type Mitarbeiter_MitarbeiterFristenError = Mitarbeiter_FristenErinnerungNachFristDatum | Mitarbeiter_ManagerNotFoundError | Mitarbeiter_MitarbeiterNotFound;

export type Mitarbeiter_ValidationErrorCode =
  | 'ArbeitsbereichDoesNotBelongToStandortError'
  | 'ArbeitsbereichError'
  | 'BefristungBeforeEintrittError'
  | 'DynamischAbwesenheitWochendurchschnittMitFlexibleArbeitstageError'
  | 'DynamischeAbwesenheitDreiMonatsdurchschnittMitFlexibleArbeitstageError'
  | 'E2nIdAlreadyExists'
  | 'GeneralError'
  | 'MissingArbeitstageError'
  | 'MissingBerechnungsartError'
  | 'MissingMonatsstundenError'
  | 'MissingStundenlohnError'
  | 'MissingStundenpensumError'
  | 'MissingTagessollError'
  | 'MissingWochenstundenError'
  | 'PersonalzugangOhneEmailError'
  | 'QualifikationenNotActivated'
  | 'TarifgruppeMitVariablemStundenlohn'
  | 'TarifgruppeNotFound'
  | 'UrlaubstageFormatError'
  | 'WochenkontoMitDynamischerAbwesenheitError';

/** mitarbeiterrechte */
export type Mitarbeiterrechte = {
  __typename: 'Mitarbeiterrechte';
  dokumente: Scalars['Boolean']['output'];
  eingeschraenkt: Scalars['Boolean']['output'];
  erlaubt: Scalars['Boolean']['output'];
  fristen: Scalars['Boolean']['output'];
  jahreskonto: Scalars['Boolean']['output'];
  personalfragebogen: Scalars['Boolean']['output'];
  rotationsplan: Scalars['Boolean']['output'];
  standortwechsel: Scalars['Boolean']['output'];
  urlaubskonto: Scalars['Boolean']['output'];
  verfuegbarkeit: Scalars['Boolean']['output'];
};

export type Money = {
  __typename: 'Money';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type MoneyInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
};

export type Mutation = {
  __typename: 'Mutation';
  arbeitszeitantragAblehnen: ArbeitszeitantragAblehnenResult;
  arbeitszeitantragGenehmigen: ArbeitszeitantragGenehmigenResult;
  arbeitszeiten_abwesenheiten_delete: Arbeitszeiten_AbwesenheitMutationResponse;
  createArbeitszeit: ArbeitszeitCreateResult;
  createManyArbeitszeiten: Array<ArbeitszeitManyCreateResult>;
  createMitarbeiter: MitarbeiterResult;
  createOrUpdateAbsatzPlan: AbsatzPlanUpdateResult;
  createOrUpdateAbsatzziel: AbsatzZielUpdateResult;
  createOrUpdateInterneNotiz: TagesInformationenInterneNotizUpdateResult;
  createOrUpdateUmsatzPlan: UmsatzPlanUpdateResult;
  createOrUpdateUmsatzZiel: UmsatzZielUpdateResult;
  deleteArbeitszeit: ArbeitszeitDeleteResult;
  dienstplan_createBelegungen: Dienstplan_Belegungen;
  dienstplan_deleteBelegung: Scalars['Boolean']['output'];
  dienstplan_updateBelegung: Scalars['Boolean']['output'];
  dienstplan_update_einstellungen?: Maybe<Dienstplan_Einstellungen>;
  manager_UpdateManagerSettings: ManagerSettingsResult;
  mitarbeiter_createAbschnitt: Mitarbeiter_CreateAbschnittMutationResponse;
  mitarbeiter_createArbeitsbereichStation: Mitarbeiter_CreateArbeitsbereichStationMutationResponse;
  mitarbeiter_createRotationsplan: Mitarbeiter_Rotationsplan;
  mitarbeiter_createRotationsplanBewertung: Mitarbeiter_CreateOrUpdateRotationsplanBewertungMutationResponse;
  mitarbeiter_deleteAbschnitt: Mitarbeiter_AbschnittDeleteMutationResponse;
  mitarbeiter_deleteArbeitsbereichStation: Mitarbeiter_ArbeitsbereichStationDeleteMutationResponse;
  mitarbeiter_deleteRotationsplan: Mitarbeiter_RotationsplanDeleteMutationResponse;
  mitarbeiter_deleteRotationsplanBewertung: Mitarbeiter_DeleteRotationsplanBewertungMutationResponse;
  mitarbeiter_mitarbeiterCreate: Mitarbeiter_MitarbeiterCreateResponse;
  mitarbeiter_updateArbeitsbereichStation: Mitarbeiter_UpdateArbeitsbereichStationMutationResponse;
  mitarbeiter_updateRotationsplanBewertung: Mitarbeiter_CreateOrUpdateRotationsplanBewertungMutationResponse;
  navigation_updateFristGelesen: Scalars['Boolean']['output'];
  navigation_updateNewsItem: Navigation_NewsUpdateMutationResponse;
  navigation_updateSchichttauschAntrag: Navigation_SchichttauschantraegeUpdateMutationResponse;
  termine_arbeitszeitVerknuepfungDelete: Termine_DeleteArbeitszeitVerknuepfung;
  termine_managerDesignSettingsUpdate: Termine_ManagerDesignSettingsUpdateResponse;
  termine_schichtVerknuepfungDelete: Termine_DeleteSchichtVerknuepfung;
  termine_terminCreate: Termine_TerminCreateResponse;
  termine_terminDelete: Termine_TerminDeleteResponse;
  termine_terminKalenderCreate: Termine_TerminKalenderCreateResponse;
  termine_terminKalenderDelete: Termine_TerminKalenderDeleteResponse;
  termine_terminUpdate: Termine_TerminUpdateResponse;
  termine_terminkalenderUpdate: Termine_TerminkalenderUpdateResponse;
  updateArbeitszeit: ArbeitszeitUpdateResult;
  updateArbeitszeitTerminVerknuepfung: Arbeitszeiten_TerminMutationResponse;
  updateDienstplanuebernahme: Array<ArbeitszeitenDienstplanuebernahmen>;
  updateTagebuchEinstellungen: TagebuchEinstellungenUpdateResult;
  vertraege_kuendigen: Scalars['Boolean']['output'];
  vertraege_upgraden: Scalars['Boolean']['output'];
};


export type MutationArbeitszeitantragAblehnenArgs = {
  input: ArbeitszeitantragAblehnenInput;
};


export type MutationArbeitszeitantragGenehmigenArgs = {
  input: ArbeitszeitantragGenehmigenInput;
};


export type MutationArbeitszeiten_Abwesenheiten_DeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateArbeitszeitArgs = {
  arbeitszeitCreateInput: CreateArbeitszeitenInput2;
  datum: Scalars['Date']['input'];
  mitarbeiterId: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};


export type MutationCreateManyArbeitszeitenArgs = {
  input: Array<CreateArbeitszeitenBulkInput>;
};


export type MutationCreateMitarbeiterArgs = {
  createMitarbeiterInput: CreateMitarbeiterInputResolver;
  idStandort: Scalars['String']['input'];
};


export type MutationCreateOrUpdateAbsatzPlanArgs = {
  createOrUpdateAbsatzPlanInput: CreateOrUpdateAbsatzPlan;
};


export type MutationCreateOrUpdateAbsatzzielArgs = {
  createOrUpdateAbsatzzielInput: CreateOrUpdateAbsatzziel;
};


export type MutationCreateOrUpdateInterneNotizArgs = {
  createOrUpdateInterneNotizInput: CreateOrUpdateInterneNotiz;
};


export type MutationCreateOrUpdateUmsatzPlanArgs = {
  createOrUpdateUmsatzPlanInput: CreateOrUpdateUmsatzPlan;
};


export type MutationCreateOrUpdateUmsatzZielArgs = {
  createOrUpdateUmsatzzielInput: CreateOrUpdateUmsatzziel;
};


export type MutationDeleteArbeitszeitArgs = {
  arbeitszeitId: Scalars['String']['input'];
};


export type MutationDienstplan_CreateBelegungenArgs = {
  createBelegungenInput: Dienstplan_Create_Belegungen_Input;
};


export type MutationDienstplan_DeleteBelegungArgs = {
  belegungId: Scalars['String']['input'];
};


export type MutationDienstplan_UpdateBelegungArgs = {
  input: Dienstplan_UpdateBelegungenInput;
};


export type MutationDienstplan_Update_EinstellungenArgs = {
  input: Dienstplan_Update_Einstellungen_Input;
};


export type MutationManager_UpdateManagerSettingsArgs = {
  managerSettings: Manager_ManagerSettingsUpdateInput;
};


export type MutationMitarbeiter_CreateAbschnittArgs = {
  createAbschnittInput: Mitarbeiter_CreateAbschnittInput;
};


export type MutationMitarbeiter_CreateArbeitsbereichStationArgs = {
  input: Mitarbeiter_CreateArbeitsbereichStationInput;
};


export type MutationMitarbeiter_CreateRotationsplanArgs = {
  createRotationsplanInput: Mitarbeiter_CreateRotationsplanInput;
};


export type MutationMitarbeiter_CreateRotationsplanBewertungArgs = {
  input: Mitarbeiter_CreateRotationsplanBewertungInput;
};


export type MutationMitarbeiter_DeleteAbschnittArgs = {
  abschnittId: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  rotationsplanId: Scalars['String']['input'];
};


export type MutationMitarbeiter_DeleteArbeitsbereichStationArgs = {
  arbeitsbereichStationId: Scalars['String']['input'];
  fristId?: InputMaybe<Scalars['String']['input']>;
  standortwechselId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMitarbeiter_DeleteRotationsplanArgs = {
  rotationsplanId: Scalars['String']['input'];
};


export type MutationMitarbeiter_DeleteRotationsplanBewertungArgs = {
  id: Scalars['String']['input'];
};


export type MutationMitarbeiter_MitarbeiterCreateArgs = {
  input: Mitarbeiter_MitarbeiterCreateInput;
  standortId: Scalars['String']['input'];
};


export type MutationMitarbeiter_UpdateArbeitsbereichStationArgs = {
  input: Mitarbeiter_UpdateArbeitsbereichStationInput;
};


export type MutationMitarbeiter_UpdateRotationsplanBewertungArgs = {
  input: Mitarbeiter_UpdateRotationsplanBewertungInput;
};


export type MutationNavigation_UpdateFristGelesenArgs = {
  input: Navigation_UpdateFristGelesenInput;
};


export type MutationNavigation_UpdateNewsItemArgs = {
  istGelesen: Scalars['Boolean']['input'];
  newsItemId: Scalars['String']['input'];
};


export type MutationNavigation_UpdateSchichttauschAntragArgs = {
  updateSchichttauschAntragInput: Navigation_UpdateSchichttauschInput;
};


export type MutationTermine_ArbeitszeitVerknuepfungDeleteArgs = {
  idArbeitszeiten: Array<Scalars['String']['input']>;
  idTerminDefinition: Scalars['String']['input'];
};


export type MutationTermine_ManagerDesignSettingsUpdateArgs = {
  termine_managerDesignSettingsUpdateInput: Termine_ManagerDesignSettingsUpdateInput;
};


export type MutationTermine_SchichtVerknuepfungDeleteArgs = {
  idSchichten: Array<Scalars['String']['input']>;
  idTerminDefinition: Scalars['String']['input'];
};


export type MutationTermine_TerminCreateArgs = {
  termin: Termine_TerminCreateInput;
};


export type MutationTermine_TerminDeleteArgs = {
  idTerminDefinitionen: Scalars['String']['input'];
};


export type MutationTermine_TerminKalenderCreateArgs = {
  input: Termine_TerminKalenderCreateInput;
};


export type MutationTermine_TerminKalenderDeleteArgs = {
  deleteKalenderInput: Termine_DeleteKalender;
};


export type MutationTermine_TerminUpdateArgs = {
  termin: Termine_TerminUpdateInput;
};


export type MutationTermine_TerminkalenderUpdateArgs = {
  updateKalenderInput: Termine_UpdateKalender;
};


export type MutationUpdateArbeitszeitArgs = {
  arbeitszeitId: Scalars['String']['input'];
  arbeitszeitUpdateInput: UpdateArbeitszeitenInput;
};


export type MutationUpdateArbeitszeitTerminVerknuepfungArgs = {
  arbeitszeitId: Scalars['String']['input'];
  terminId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDienstplanuebernahmeArgs = {
  updateDienstplanuebernahmeInput: Array<UpdateDienstplanuebernahmeInput>;
};


export type MutationUpdateTagebuchEinstellungenArgs = {
  updateTagebuchEinstellungenInput: TagebuchEinstellungenUpdateInput;
};


export type MutationVertraege_KuendigenArgs = {
  input: Vertraege_Kuendigen;
};


export type MutationVertraege_UpgradenArgs = {
  input: Vertraege_Upgrade;
};

export type Personalfragebogen = {
  __typename: 'Personalfragebogen';
  erstellungsDatum: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
};

export type Personalzugang_ErrorCode =
  | 'AlreadyExists'
  | 'E2nIdNotFound'
  | 'EinladungEmailEmpty'
  | 'EinladungMitarbeiterNotFound'
  | 'EinladungPersonalzugangNotFound'
  | 'EmailNotFound'
  | 'KontakteWithEigeneDatenNotAllowed'
  | 'MitarbeiterNotFound'
  | 'Unknown';

export type Plansoll = {
  exakteMonatssollBerechnung?: InputMaybe<Scalars['Boolean']['input']>;
  richtwertMonatssollBetrag?: InputMaybe<Scalars['Float']['input']>;
  richtwertMonatssollZeit?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename: 'Query';
  Anlageassistent_getMitarbeiterPersonalIds: Mitarbeiter_PersonalIdsResponse;
  Anlageassistent_validateEmail: Mitarbeiter_EmailValidation;
  abteilungenByStandortId: AbteilungResult;
  antraegeByStandortId: AntraegeResult;
  arbeitsbereicheByIdStandort: ArbeitsbereichResult;
  arbeitszeitById: Arbeitszeiten;
  arbeitszeiten: ArbeitszeitenResult;
  arbeitszeiten_antrag: ArbeitszeitAntrag;
  controlling: Array<Controlling>;
  controlling_mindestbelegungByStandortIdAndDatum: Controlling_Mindestbelegung;
  dienstplan_arbeitsbereich: Array<Dienstplan_Arbeitsbereich>;
  dienstplan_findAllBelegungen: Array<Dienstplan_Belegungen>;
  dienstplan_findStandortById: Dienstplan_Standorte;
  dienstplanuebernahmen: Array<ArbeitszeitenDienstplanuebernahmen>;
  feiertagByStandortIdAndDatum?: Maybe<Feiertag>;
  findAllToDosForDatepicker: Array<DatePickerToDo>;
  historieByStandortIdAndDatum: TagebuchHistorie;
  manager: ManagerResult;
  mitarbeiter: MitarbeiterResult;
  mitarbeiter_abteilungsleiterByStandortIdsAndArbeitsbereichId: Array<Mitarbeiter_Abteilungsleiter2>;
  mitarbeiter_arbeitsbereicheByStandortIds: Array<Mitarbeiter_Arbeitsbereiche>;
  mitarbeiter_existiertPersonalnummerInAnderemStandort: Mitarbeiter_ExistiertPersonalnummerInAnderemStandort;
  mitarbeiter_getAllManagerByStandortId: Array<Mitarbeiter_Manager>;
  mitarbeiter_mitarbeiterByStandortIds: Array<Mitarbeiter_Mitarbeiter>;
  mitarbeiter_rotationsplaeneByStandortIds: Array<Mitarbeiter_Rotationsplan>;
  mitarbeiter_rotationsplanById?: Maybe<Mitarbeiter_Rotationsplan>;
  mitarbeiter_standortById: Mitarbeiter_Standorte;
  mitarbeiter_standortgruppeById: Mitarbeiter_Standortgruppen;
  /** @deprecated War nicht allgemein genug gehalten, wird ausgebaut nach der umstellung auf die neue Query */
  navigation_benachrichtigungen: Array<Navigation_Benachrichtigungen>;
  navigation_benachrichtigungen2?: Maybe<Navigation_Benachrichtigungen>;
  navigation_manager: Navigation_ManagerResult;
  navigation_mitarbeiter: Array<Navigation_Mitarbeiter2>;
  navigation_standortgruppeById: Navigation_Standortgruppen;
  search: Array<Navigation_SearchResult>;
  termine: TermineResult;
  termine_feiertageByStandortIdsAndZeitraum: Array<Termine_Feiertag>;
  termine_manager: Termine_ManagerResult;
  /** Fetch Terminkalender by Standort IDs and Zeitraum. */
  termine_termineKalenderByStandortIdAndZeitraum: Array<Termine_Kalender>;
  toDos: Array<ToDoUnion>;
  vertraegeByIdStandort: Array<Vertrag>;
  zuschlagsgruppenByIdStandorte: ZuschlagsgruppeResult;
};


export type QueryAnlageassistent_GetMitarbeiterPersonalIdsArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryAnlageassistent_ValidateEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryAbteilungenByStandortIdArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryAntraegeByStandortIdArgs = {
  datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryArbeitsbereicheByIdStandortArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryArbeitszeitByIdArgs = {
  idArbeitszeit: Scalars['String']['input'];
};


export type QueryArbeitszeitenArgs = {
  datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryArbeitszeiten_AntragArgs = {
  datum: Scalars['String']['input'];
  id: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryControllingArgs = {
  standortIds: Array<Scalars['String']['input']>;
};


export type QueryControlling_MindestbelegungByStandortIdAndDatumArgs = {
  datum: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryDienstplan_ArbeitsbereichArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryDienstplan_FindAllBelegungenArgs = {
  standortId: Scalars['String']['input'];
  tage: Array<Dienstplan_Tag>;
};


export type QueryDienstplan_FindStandortByIdArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryDienstplanuebernahmenArgs = {
  datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryFeiertagByStandortIdAndDatumArgs = {
  datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryFindAllToDosForDatepickerArgs = {
  bis: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
  von: Scalars['Date']['input'];
};


export type QueryHistorieByStandortIdAndDatumArgs = {
  datum: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryMitarbeiterArgs = {
  date: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryMitarbeiter_AbteilungsleiterByStandortIdsAndArbeitsbereichIdArgs = {
  arbeitsbereichId?: InputMaybe<Scalars['String']['input']>;
  standortIds: Array<Scalars['String']['input']>;
};


export type QueryMitarbeiter_ArbeitsbereicheByStandortIdsArgs = {
  standortIds: Array<Scalars['String']['input']>;
};


export type QueryMitarbeiter_ExistiertPersonalnummerInAnderemStandortArgs = {
  mitarbeiterId: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryMitarbeiter_GetAllManagerByStandortIdArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryMitarbeiter_MitarbeiterByStandortIdsArgs = {
  standortIds: Array<Scalars['String']['input']>;
  status?: InputMaybe<Mitarbeiter_MitarbeiterStatus>;
};


export type QueryMitarbeiter_RotationsplaeneByStandortIdsArgs = {
  standortIds: Array<Scalars['String']['input']>;
};


export type QueryMitarbeiter_RotationsplanByIdArgs = {
  rotationsplanId: Scalars['String']['input'];
};


export type QueryMitarbeiter_StandortByIdArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryMitarbeiter_StandortgruppeByIdArgs = {
  standortGruppenId: Scalars['String']['input'];
};


export type QueryNavigation_BenachrichtigungenArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryNavigation_Benachrichtigungen2Args = {
  standortId: Scalars['String']['input'];
};


export type QueryNavigation_MitarbeiterArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryNavigation_StandortgruppeByIdArgs = {
  standortGruppenId: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryTermineArgs = {
  datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryTermine_FeiertageByStandortIdsAndZeitraumArgs = {
  standortIds: Array<Scalars['String']['input']>;
  zeitraum: ZeitraumInput;
};


export type QueryTermine_TermineKalenderByStandortIdAndZeitraumArgs = {
  standortIds: Array<Scalars['String']['input']>;
  zeitraum?: InputMaybe<ZeitraumInput>;
};


export type QueryToDosArgs = {
  Datum: Scalars['Date']['input'];
  standortId: Scalars['String']['input'];
};


export type QueryVertraegeByIdStandortArgs = {
  standortId: Scalars['String']['input'];
};


export type QueryZuschlagsgruppenByIdStandorteArgs = {
  standortId: Scalars['String']['input'];
};

export type RotationsplanAbwesenheitsgruende =
  | 'Arbeitsunfall'
  | 'Arztbesuch'
  | 'Ausgleichsruhezeitentag'
  | 'Beschaeftigungsverbot'
  | 'BezahlterArbeitsfreierTag'
  | 'Bildung'
  | 'EURente'
  | 'Elternzeit'
  | 'FehltUnentschuldigt'
  | 'Feiertag'
  | 'Feiertagsausgleich'
  | 'FeiertagsausgleichDynamisch'
  | 'Ferientag'
  | 'Frei'
  | 'Freistellung'
  | 'GuttagMinus'
  | 'GuttagPlus'
  | 'Kompensationstag'
  | 'Krank'
  | 'KrankImFrei'
  | 'KrankInKurzarbeit'
  | 'KrankOhneLohnfortzahlung'
  | 'Krankengeld'
  | 'KrankesKind'
  | 'Kur'
  | 'Kurzarbeit'
  | 'Lehrgang'
  | 'MilitaerZivildienst'
  | 'Mutterschaft'
  | 'Mutterschutz'
  | 'Papamonat'
  | 'Quarantaene'
  | 'QuarantaeneOhneLFZ'
  | 'Ruhetag'
  | 'Schule'
  | 'Sonderurlaub'
  | 'Ueberstundenabbau'
  | 'UnbezahlterFerientag'
  | 'UnbezahlterUrlaub'
  | 'Unfall'
  | 'Urlaub'
  | 'Vaterschaft'
  | 'Wiedereingliederung'
  | 'Wunschfrei'
  | 'Wunschruhetag';

export type Schicht = {
  __typename: 'Schicht';
  beginn?: Maybe<Scalars['Date']['output']>;
  ende?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
};

export type SchichtenMarkierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Settings = {
  __typename: 'Settings';
  abteilungenEnabled: Scalars['Boolean']['output'];
  isTerminVerknuepfung: Scalars['Boolean']['output'];
  qualifikationenEnabled: Scalars['Boolean']['output'];
};

export type Sollstunden = {
  __typename: 'Sollstunden';
  aushilfen: Scalars['Int']['output'];
  festangestellt: Scalars['Int']['output'];
  jahrMonat: JahrMonat;
  standortId: Scalars['String']['output'];
};

/** standort  */
export type Standort = {
  __typename: 'Standort';
  banner?: Maybe<Banner>;
  featureFlags: Array<FeatureFlag>;
  id: Scalars['String']['output'];
  idStandortgruppe?: Maybe<Scalars['String']['output']>;
  isAuditAktiv: Scalars['Boolean']['output'];
  isGuttagekontenAktiviert: Scalars['Boolean']['output'];
  isMonatAbgeschlossen?: Maybe<Scalars['Boolean']['output']>;
  land: Scalars['String']['output'];
  lohnabrechnungseinstellungen: Lohnabrechnungseinstellungen;
  name: Scalars['String']['output'];
  schluessel: Scalars['String']['output'];
  settings?: Maybe<Settings>;
  storeNummer?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};


/** standort  */
export type StandortIsMonatAbgeschlossenArgs = {
  journaltag: Scalars['Date']['input'];
};

export type Standort_Lohnabrechnungsart =
  | 'ABACUS'
  | 'ABS'
  | 'ADATA'
  | 'ADDISON'
  | 'AGENDA'
  | 'ANDERE'
  | 'BMD'
  | 'CROWE'
  | 'DATAC'
  | 'DPW'
  | 'E2NFINANCE'
  | 'EDLOHN'
  | 'EGECKO'
  | 'GDI'
  | 'HAMBURGERSOFTWARE'
  | 'HGC'
  | 'KEINE'
  | 'LEXWARE'
  | 'LODAS'
  | 'LOGE'
  | 'LOHNAG'
  | 'MIRUS'
  | 'PAISY'
  | 'PILOGA'
  | 'PROFFIX'
  | 'PROVIA'
  | 'PSSPAYROLL'
  | 'RZALOHN'
  | 'RZL'
  | 'SAGE'
  | 'SBS'
  | 'SDWORX'
  | 'SKOFFICE'
  | 'SOFTKIS'
  | 'SPDATA'
  | 'SWISSSALARY'
  | 'TOPAL'
  | 'TWODOXX'
  | 'UNBEKANNT'
  | 'ZUCCHETTI';

export type SummeNetto = {
  __typename: 'SummeNetto';
  waehrung: Scalars['String']['output'];
  wert: Scalars['Float']['output'];
};

export type TagebuchAnzeige =
  | 'Absatzproduktivitaet'
  | 'Oeffnungszeiten'
  | 'Personaleinsatz'
  | 'Personalkosten'
  | 'Produktivitaet';

export type TagebuchEinstellungen = {
  __typename: 'TagebuchEinstellungen';
  absatzProduktivitaet: AbsatzProduktivitaetEinstellungen;
  umsatzProduktivitaet: UmsatzProduktiviteatEinstellungen;
};

/** Ein Fehler ist aufgetreten und die Tagebucheinstellungen konnten nicht aktualisiert werden */
export type TagebuchEinstellungenUpdateError = {
  __typename: 'TagebuchEinstellungenUpdateError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TagebuchEinstellungenUpdateInput = {
  absatzProduktivitaet?: InputMaybe<AbsatzProduktivitaetEinstellungenInput>;
  standortId: Scalars['String']['input'];
  umsatzProduktivitaet?: InputMaybe<UmsatzProduktiviteatEinstellungenInput>;
};

export type TagebuchEinstellungenUpdateResult = TagebuchEinstellungen | TagebuchEinstellungenUpdateError;

export type TagebuchEintrag = {
  __typename: 'TagebuchEintrag';
  datum: Scalars['String']['output'];
  interneNotiz: Scalars['String']['output'];
  standortId: Scalars['String']['output'];
  wetter: Array<Wetter>;
};

export type TagebuchEintragData = {
  __typename: 'TagebuchEintragData';
  datum: Scalars['String']['output'];
  interneNotiz: Scalars['String']['output'];
  istAbsatz?: Maybe<Controlling_Absatz>;
  istUmsatz?: Maybe<Umsatz>;
  planAbsatz?: Maybe<Controlling_Absatz>;
  planUmsatz?: Maybe<Umsatz>;
  wetter?: Maybe<TagebuchEintragWetter>;
};

export type TagebuchEintragHistorie = {
  __typename: 'TagebuchEintragHistorie';
  current?: Maybe<TagebuchEintragData>;
  prevMonth?: Maybe<TagebuchEintragData>;
  prevWeek?: Maybe<TagebuchEintragData>;
  prevYear?: Maybe<TagebuchEintragData>;
};

export type TagebuchEintragWetter = {
  __typename: 'TagebuchEintragWetter';
  code?: Maybe<Scalars['Int']['output']>;
  maxTemperatur?: Maybe<Scalars['Int']['output']>;
  minTemperatur?: Maybe<Scalars['Int']['output']>;
};

export type TagebuchHistorie = {
  __typename: 'TagebuchHistorie';
  datum: Scalars['String']['output'];
  historie: TagebuchEintragHistorie;
};

/** Fehler wenn die interne Notiz der Tagesinformationen nicht geändert werden konnte */
export type TagesInformationenInterneNotizUpdateError = {
  __typename: 'TagesInformationenInterneNotizUpdateError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TagesInformationenInterneNotizUpdateResult = InterneNotiz | TagesInformationenInterneNotizUpdateError | UmsatzplanungUnkownError;

export type Temperatur = {
  __typename: 'Temperatur';
  einheit: TemperaturEinheit;
  wert: Scalars['Float']['output'];
};

export type TemperaturEinheit =
  | 'C'
  | 'F'
  | 'K';

/** termine by standort id */
export type TermineByStandortId = {
  __typename: 'TermineByStandortId';
  standortId: Scalars['String']['output'];
  termine?: Maybe<Array<Arbeitszeiten_Termine>>;
};

/** termine error */
export type TermineError = {
  __typename: 'TermineError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** termine_manager */
export type TermineManager = {
  __typename: 'TermineManager';
  designSettings: ManagerDesignSettings;
  id: Scalars['ID']['output'];
};

/** termine_manager_error */
export type TermineManagerError = {
  __typename: 'TermineManagerError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TermineResult = TermineByStandortId | TermineError;

export type ToDoAntraege = {
  __typename: 'ToDoAntraege';
  aenderungsdatum?: Maybe<Scalars['Date']['output']>;
  arbeitsbereich: ArbeitszeitArbeitsbereiche2;
  arbeitszeitId?: Maybe<Scalars['String']['output']>;
  beginn?: Maybe<ToDoAntragZeitstempel>;
  bemerkungAntragsteller?: Maybe<Scalars['String']['output']>;
  bemerkungVorgesetzter?: Maybe<Scalars['String']['output']>;
  datum?: Maybe<Scalars['String']['output']>;
  ende?: Maybe<ToDoAntragZeitstempel>;
  erstellungsdatum?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mitarbeiter: ArbeitszeitenMitarbeiter2;
  offen?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ArbeitszeitArbeitszeitantragStatus>;
};

export type ToDoAntragZeitstempel = {
  __typename: 'ToDoAntragZeitstempel';
  changeRequested: Scalars['Boolean']['output'];
  zeitstempel: Zeitstempel;
};

export type ToDoUnion = ToDoAntraege | ToDosAbwesenheiten | ToDosArbeitszeiten | ToDosKonflikte;

export type ToDosAbwesenheiten = {
  __typename: 'ToDosAbwesenheiten';
  arbeitsbereich: ArbeitszeitArbeitsbereiche2;
  dauer?: Maybe<Scalars['Int']['output']>;
  grund: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: ArbeitszeitenMitarbeiter2;
};

export type ToDosArbeitszeiten = {
  __typename: 'ToDosArbeitszeiten';
  arbeitsbereich: ArbeitszeitArbeitsbereiche2;
  beginn?: Maybe<Zeitstempel>;
  bemerkung?: Maybe<Scalars['String']['output']>;
  dauer?: Maybe<Scalars['Int']['output']>;
  ende?: Maybe<Zeitstempel>;
  gehen?: Maybe<Zeitstempel>;
  id: Scalars['String']['output'];
  kommen?: Maybe<Zeitstempel>;
  mitarbeiter: ArbeitszeitenMitarbeiter2;
  pausen: Array<Arbeitszeiten_Pausen>;
  pausenDauer?: Maybe<Scalars['Int']['output']>;
  rechtshinweise: Array<ArbeitszeitRechtshinweise>;
  termin?: Maybe<Arbeitszeiten_Termine>;
  zuschlaege: Array<Arbeitszeiten_Zuschlaege>;
};

export type ToDosKonflikte = {
  __typename: 'ToDosKonflikte';
  cause?: Maybe<Cause>;
  rootArbeitszeit: Root;
};

export type Ueberstunden = {
  berechnung?: InputMaybe<MitarbeiterCreateBerechnung>;
  berechnungZeitraum: MitarbeiterCreateBerechnungZeitraum;
  monatssoll?: InputMaybe<Scalars['Float']['input']>;
  unbezahlteUeberstunden?: InputMaybe<Scalars['Float']['input']>;
};

export type Umsatz = {
  __typename: 'Umsatz';
  produktivitaet?: Maybe<Money>;
  stunden?: Maybe<Scalars['Float']['output']>;
  wert?: Maybe<Money>;
};

export type UmsatzPlanUpdateResult = Umsatz | UmsatzUpdateResultStandortNotFound | UmsatzUpdateResultUpdateError | UmsatzplanungUnkownError;

export type UmsatzProduktiviteatEinstellungen = {
  __typename: 'UmsatzProduktiviteatEinstellungen';
  tagebuchAnzeige: TagebuchAnzeige;
  zielProduktivitaet: Scalars['Float']['output'];
};

export type UmsatzProduktiviteatEinstellungenInput = {
  zielProduktivitaet: Scalars['Float']['input'];
};

/** Fehler wenn der Standort nicht gefunden wurde */
export type UmsatzUpdateResultStandortNotFound = {
  __typename: 'UmsatzUpdateResultStandortNotFound';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Fehler wenn der Umsatz nicht geändert werden konnte */
export type UmsatzUpdateResultUpdateError = {
  __typename: 'UmsatzUpdateResultUpdateError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UmsatzZiel = {
  __typename: 'UmsatzZiel';
  jahrMonat: JahrMonat;
  standortId: Scalars['String']['output'];
  umsatz: Umsatz;
};

export type UmsatzZielUpdateResult = Umsatz | UmsatzUpdateResultStandortNotFound | UmsatzUpdateResultUpdateError | UmsatzplanungUnkownError;

/** Ein Fehler ist aufgetreten und das Umsatzziel konnte nicht aktualisiert werden */
export type UmsatzplanungUnkownError = {
  __typename: 'UmsatzplanungUnkownError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Unbekannter Fehler beim Update der Arbeitszeit */
export type UnknownError = {
  __typename: 'UnknownError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpdateArbeitszeitenInput = {
  arbeitsbereichId?: InputMaybe<Scalars['String']['input']>;
  beginn?: InputMaybe<Scalars['String']['input']>;
  /** Die Bemerkung zur Arbeitszeit hat maximal 250 Zeichen. */
  bemerkung?: InputMaybe<Scalars['String']['input']>;
  ende?: InputMaybe<Scalars['String']['input']>;
  pausen?: InputMaybe<Array<ArbeitszeitenPausenInput>>;
  pauseneinstellung?: InputMaybe<ArbeitszeitenPauseneinstellung>;
};

export type UpdateDienstplanuebernahmeInput = {
  ignoriert: Scalars['Boolean']['input'];
  mitarbeiterId: Scalars['String']['input'];
  schichtId: Scalars['String']['input'];
};

export type Vertraege_KuendigungErrorCode =
  | 'ManagerDarfNichtKuendigen'
  | 'ManagerNotFound'
  | 'Unknown'
  | 'VertragBereitsGekuendigt'
  | 'VertragNichtLadbar'
  | 'VertragNotFound';

/** vertrag  */
export type Vertrag = {
  __typename: 'Vertrag';
  aktiv: Scalars['Boolean']['output'];
  aktiveAnzahl: Scalars['Float']['output'];
  art: Scalars['String']['output'];
  faelligkeitsdatum?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kuendigung?: Maybe<Admin_Kuendigung>;
  kundennummer: Scalars['Float']['output'];
  preisModell: Scalars['String']['output'];
  summeNetto: SummeNetto;
  unternehmensname: Scalars['String']['output'];
  vereinbarteAnzahl: Scalars['Float']['output'];
  vertragIntervall: VertragIntervall;
  vertragTarif: VertragTarif;
  vertragZahlungsmethode: VertragZahlungsmethode;
  vertragstatus: VertragStatus;
};

export type VertragIntervall =
  | 'JAHR'
  | 'MONAT'
  | 'UNBEKANNT';

export type VertragStatus =
  | 'AKTIV'
  | 'BEENDET'
  | 'GEKUENDIGT'
  | 'ZU_KLAEREN';

export type VertragTarif =
  | 'MITARBEITER'
  | 'STANDORTE'
  | 'UNBEKANNT';

export type VertragZahlungsmethode =
  | 'SEPA'
  | 'UEBERWEISUNG'
  | 'UNBEKANNT';

export type Wetter = {
  __typename: 'Wetter';
  datum: Scalars['String']['output'];
  maxTemperatur: Temperatur;
  minTemperatur: Temperatur;
  niederschlagWahrscheinlichkeit: Scalars['Float']['output'];
  uhrzeit: Scalars['String']['output'];
  wetterZustand: Scalars['String']['output'];
  wettercode: Scalars['Float']['output'];
};

export type ZeitraumInput = {
  bis: Scalars['String']['input'];
  von: Scalars['String']['input'];
};

export type Zeitstempel = {
  __typename: 'Zeitstempel';
  abweichung?: Maybe<Scalars['Int']['output']>;
  schicht?: Maybe<Schicht>;
  zeitpunkt?: Maybe<Scalars['Date']['output']>;
};

export type Zuschlagsgruppe = {
  __typename: 'Zuschlagsgruppe';
  id: Scalars['ID']['output'];
  idStandort: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ZuschlagsgruppeByIdStandort = {
  __typename: 'ZuschlagsgruppeByIdStandort';
  standortId: Scalars['String']['output'];
  zuschlagsgruppen: Array<Zuschlagsgruppe>;
};

/** zuschlagsgruppe error */
export type ZuschlagsgruppeError = {
  __typename: 'ZuschlagsgruppeError';
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ZuschlagsgruppeResult = ZuschlagsgruppeByIdStandort | ZuschlagsgruppeError;

export type Admin_Kuendigung = {
  __typename: 'admin_kuendigung';
  gekuendigtAm: Scalars['Date']['output'];
  gekuendigtVon: Scalars['String']['output'];
};

export type Arbeitszeiten_Antragszeit = {
  __typename: 'arbeitszeiten_antragszeit';
  isChangeRequested: Scalars['Boolean']['output'];
  time: Scalars['Date']['output'];
};

export type Arbeitszeiten_Pausen = {
  __typename: 'arbeitszeiten_pausen';
  art: ArbeitszeitenPausenart;
  beginn?: Maybe<Scalars['Date']['output']>;
  bezahlt: Scalars['Boolean']['output'];
  dauer?: Maybe<Scalars['Int']['output']>;
  ende?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Arbeitszeiten_Termine = {
  __typename: 'arbeitszeiten_termine';
  beginn: Scalars['Date']['output'];
  beschreibung?: Maybe<Scalars['String']['output']>;
  bildName?: Maybe<Scalars['String']['output']>;
  bildUrl?: Maybe<Scalars['String']['output']>;
  ende: Scalars['Date']['output'];
  id?: Maybe<Scalars['String']['output']>;
  markierung?: Maybe<Markierung>;
  standortId?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  wiederholung?: Maybe<ArbeitszeitTermineWiederholung>;
};

export type Arbeitszeiten_Zuschlaege = {
  __typename: 'arbeitszeiten_zuschlaege';
  betrag: Arbeitszeiten_Zuschlaege_Betrag_Union;
  dauer: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  prozent: Scalars['Float']['output'];
};

export type Arbeitszeiten_Zuschlaege_Betrag = {
  __typename: 'arbeitszeiten_zuschlaege_betrag';
  betrag: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type Arbeitszeiten_Zuschlaege_Betrag_Union = Arbeitszeiten_Zuschlaege_Betrag | Arbeitszeiten_Zuschlaege_NoAccess;

export type Arbeitszeiten_Zuschlaege_NoAccess = {
  __typename: 'arbeitszeiten_zuschlaege_noAccess';
  message: Scalars['String']['output'];
};

export type Cause = ToDosAbwesenheiten | ToDosArbeitszeiten;

export type Controlling_Absatz = {
  __typename: 'controlling_Absatz';
  produktivitaet?: Maybe<Controlling_AbsatzProduktivitaet>;
  stunden?: Maybe<Scalars['Float']['output']>;
  wert?: Maybe<Scalars['Int']['output']>;
};

export type Controlling_AbsatzPlan = {
  __typename: 'controlling_AbsatzPlan';
  datum: Scalars['String']['output'];
  interneNotiz: Scalars['String']['output'];
  plan: Controlling_Absatz;
  prognose?: Maybe<Scalars['Int']['output']>;
  standortId: Scalars['String']['output'];
};

export type Controlling_AbsatzProduktivitaet = {
  __typename: 'controlling_AbsatzProduktivitaet';
  mpt?: Maybe<Scalars['Float']['output']>;
  stueck?: Maybe<Scalars['Float']['output']>;
};

export type Controlling_AbsatzZiel = {
  __typename: 'controlling_AbsatzZiel';
  absatz: Controlling_Absatz;
  jahrMonat: JahrMonat;
  standortId: Scalars['String']['output'];
};

export type Controlling_Planwert = {
  __typename: 'controlling_Planwert';
  absatzPlan: Controlling_AbsatzPlan;
  datum: Scalars['String']['output'];
  interneNotiz: Scalars['String']['output'];
  standortId: Scalars['String']['output'];
  umsatzPlan: Controlling_UmsatzPlan;
};

export type Controlling_UmsatzPlan = {
  __typename: 'controlling_UmsatzPlan';
  datum: Scalars['String']['output'];
  interneNotiz: Scalars['String']['output'];
  plan: Umsatz;
  prognose?: Maybe<Money>;
  standortId: Scalars['String']['output'];
};

export type Controlling_Mindestbelegung = {
  __typename: 'controlling_mindestbelegung';
  dauer: Scalars['Int']['output'];
};

export type Dienstplan_Arbeitsbereich = {
  __typename: 'dienstplan_arbeitsbereich';
  id: Scalars['String']['output'];
  markierung: Dienstplan_ArbeitsbereichMarkierung;
  mindestbelegung: Array<Dienstplan_Mindestbelegung>;
  name: Scalars['String']['output'];
};

export type Dienstplan_ArbeitsbereichMarkierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Dienstplan_Belegung = {
  __typename: 'dienstplan_belegung';
  anzahlMitarbeiter: Scalars['Float']['output'];
  dauer: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  von: Scalars['String']['output'];
};

export type Dienstplan_Belegungen = {
  __typename: 'dienstplan_belegungen';
  anzahlMitarbeiter: Scalars['Int']['output'];
  arbeitsbereich: Dienstplan_Arbeitsbereich;
  dauer: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  von: Scalars['String']['output'];
  wochentag: Dienstplan_Tag;
};

export type Dienstplan_Create_Belegungen_Input = {
  anzahlMitarbeiter: Scalars['Int']['input'];
  arbeitsbereichId: Scalars['String']['input'];
  dauer: Scalars['Int']['input'];
  managerId: Scalars['String']['input'];
  tag: Dienstplan_Tag;
  von: Scalars['String']['input'];
};

export type Dienstplan_Einstellungen = {
  __typename: 'dienstplan_einstellungen';
  bemerkung: Scalars['String']['output'];
  maxAnzahlMitarbeiter: Scalars['Float']['output'];
  maximaleSchichtlaenge: Scalars['Int']['output'];
  minimaleSchichtlaenge: Scalars['Int']['output'];
  schichtplanung: Scalars['Boolean']['output'];
  schichtuebergabe?: Maybe<Scalars['Int']['output']>;
  unbesetzteSchichten: Scalars['Boolean']['output'];
};

export type Dienstplan_Mindestbelegung = {
  __typename: 'dienstplan_mindestbelegung';
  belegungen: Array<Dienstplan_Belegung>;
  einstellungen: Dienstplan_Einstellungen;
  tag: Dienstplan_Tag;
};

export type Dienstplan_Standorte = {
  __typename: 'dienstplan_standorte';
  tageswechsel?: Maybe<Scalars['String']['output']>;
};

export type Dienstplan_Tag =
  | 'DIENSTAG'
  | 'DONNERSTAG'
  | 'FEIERTAG'
  | 'FREITAG'
  | 'MITTWOCH'
  | 'MONTAG'
  | 'SAMSTAG'
  | 'SONNTAG';

export type Dienstplan_UpdateBelegungenInput = {
  anzahlMitarbeiter: Scalars['Int']['input'];
  dauer: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  von: Scalars['String']['input'];
};

export type Dienstplan_Update_Einstellungen_Input = {
  bemerkung: Scalars['String']['input'];
  idArbeitsbereich: Scalars['String']['input'];
  managerId: Scalars['String']['input'];
  maxMitarbeiterAnzahl: Scalars['Float']['input'];
  maximaleSchichtlaenge: Scalars['Float']['input'];
  minimaleSchichtlaenge: Scalars['Float']['input'];
  schichtplanungBeruecksichtigen: Scalars['Boolean']['input'];
  schichtuebergabe: Scalars['Int']['input'];
  tag: Dienstplan_Tag;
  unbesetzteSchichtenErlauben: Scalars['Boolean']['input'];
};

export type Manager_ManagerSettingsError = {
  __typename: 'manager_ManagerSettingsError';
  message: Scalars['String']['output'];
};

export type Manager_ManagerSettingsUpdateInput = {
  arbeitszeitenDesign?: InputMaybe<Scalars['String']['input']>;
};

export type Mitarbeiter_CreateArbeitsbereichStationSuccess = {
  __typename: 'mitarbeiter_CreateArbeitsbereichStationSuccess';
  fristResult?: Maybe<Mitarbeiter_CreateOrUpdateArbeitsbereichStationFristResponse>;
  station: Mitarbeiter_RotationsplanStation;
};

export type Mitarbeiter_CreateOrUpdateArbeitsbereichStationFristResponse = {
  __typename: 'mitarbeiter_CreateOrUpdateArbeitsbereichStationFristResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_Frist>;
};

export type Mitarbeiter_DeleteArbeitsbereichStationFristResponse = {
  __typename: 'mitarbeiter_DeleteArbeitsbereichStationFristResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_DeleteArbeitsbereichStationStandortwechselResponse = {
  __typename: 'mitarbeiter_DeleteArbeitsbereichStationStandortwechselResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_Frist = {
  __typename: 'mitarbeiter_Frist';
  aenderungsdatum: Scalars['Date']['output'];
  bemerkung: Scalars['String']['output'];
  erinnerungen: Array<Mitarbeiter_FristenErinnerungen>;
  erstellungsdatum: Scalars['Date']['output'];
  fristDatum: Scalars['Date']['output'];
  grund: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Mitarbeiter_FristenErinnerungNachFristDatum = Mitarbeiter_MitarbeiterAbstractError & {
  __typename: 'mitarbeiter_FristenErinnerungNachFristDatum';
  invalidErinnernAm: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_ManagerNotFoundError = Mitarbeiter_MitarbeiterAbstractError & {
  __typename: 'mitarbeiter_ManagerNotFoundError';
  managerIds: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterAbstractError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterCreateResponse = {
  __typename: 'mitarbeiter_MitarbeiterCreateResponse';
  error?: Maybe<Mitarbeiter_MitarbeiterGeneralError>;
  success?: Maybe<Mitarbeiter_MitarbeiterCreateSuccess>;
  validationErrors?: Maybe<Array<Mitarbeiter_MitarbeiterValidationError>>;
};

export type Mitarbeiter_MitarbeiterCreateSuccess = {
  __typename: 'mitarbeiter_MitarbeiterCreateSuccess';
  fristenResult?: Maybe<Mitarbeiter_MitarbeiterFristenCreateResponse>;
  mitarbeiter: Mitarbeiter_Mitarbeiter;
  personalzugang?: Maybe<Personalzugang_CreateResponse>;
};

export type Mitarbeiter_MitarbeiterEmailCheckFindingBlacklist = {
  __typename: 'mitarbeiter_MitarbeiterEmailCheckFindingBlacklist';
  erstellungsdatum?: Maybe<Scalars['String']['output']>;
  grund?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterEmailCheckFindingInvalidFormat = {
  __typename: 'mitarbeiter_MitarbeiterEmailCheckFindingInvalidFormat';
  details?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterEmailCheckFindingTooLong = {
  __typename: 'mitarbeiter_MitarbeiterEmailCheckFindingTooLong';
  maxSize: Scalars['Int']['output'];
};

export type Mitarbeiter_MitarbeiterEmailCheckFindingUnknown = {
  __typename: 'mitarbeiter_MitarbeiterEmailCheckFindingUnknown';
  details?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterGeneralError = Mitarbeiter_MitarbeiterAbstractError & {
  __typename: 'mitarbeiter_MitarbeiterGeneralError';
  message?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_MitarbeiterNotFound = Mitarbeiter_MitarbeiterAbstractError & {
  __typename: 'mitarbeiter_MitarbeiterNotFound';
  message?: Maybe<Scalars['String']['output']>;
  mitarbeiterId: Scalars['String']['output'];
};

export type Mitarbeiter_MitarbeiterValidationError = {
  __typename: 'mitarbeiter_MitarbeiterValidationError';
  errorCode: Mitarbeiter_ValidationErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_RotationsplanGeneralError = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_RotationsplanGeneralError';
  message: Scalars['String']['output'];
};

export type Mitarbeiter_UpdateArbeitsbereichStationSuccess = {
  __typename: 'mitarbeiter_UpdateArbeitsbereichStationSuccess';
  fristResult?: Maybe<Mitarbeiter_UpdateArbeitsbereichStationSuccessFristenResultUnion>;
  station: Mitarbeiter_RotationsplanStation;
};

export type Mitarbeiter_AbschnittDeleteMutationResponse = {
  __typename: 'mitarbeiter_abschnittDeleteMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_AbschnittDeleteSuccess>;
};

export type Mitarbeiter_AbschnittDeleteSuccess = {
  __typename: 'mitarbeiter_abschnittDeleteSuccess';
  abschnittId: Scalars['String']['output'];
  details: Scalars['String']['output'];
};

export type Mitarbeiter_Abteilungsleiter = {
  __typename: 'mitarbeiter_abteilungsleiter';
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type Mitarbeiter_Abteilungsleiter2 = {
  __typename: 'mitarbeiter_abteilungsleiter2';
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type Mitarbeiter_Anrede =
  | 'DIVERS'
  | 'FRAU'
  | 'HERR';

export type Mitarbeiter_Anstellungstyp =
  | 'AZUBI'
  | 'EHRENAMTLICH'
  | 'KURZ_MIT_LSTK'
  | 'KURZ_OHNE_LSTK'
  | 'MIDIJOB'
  | 'MINIJOB'
  | 'PRAKTIKANT'
  | 'SELBSTSTAENDIG'
  | 'TEILZEIT'
  | 'VOLLZEIT'
  | 'WERKSTUDENT';

export type Mitarbeiter_AnzahlArbeitstage =
  | 'DREI_TAGE'
  | 'EIN_TAG'
  | 'FLEXIBEL'
  | 'FUENF_TAGE'
  | 'SECHS_TAGE'
  | 'SIEBEN_TAGE'
  | 'VIER_TAGE'
  | 'ZWEI_TAGE';

export type Mitarbeiter_ArbeitnehmerTyp =
  | 'AZUBI'
  | 'EHRENAMTLICH'
  | 'KURZ_MIT_LSTK'
  | 'KURZ_OHNE_LSTK'
  | 'MIDIJOB'
  | 'MINIJOB'
  | 'PRAKTIKANT'
  | 'SELBSTSTAENDIG'
  | 'TEILZEIT'
  | 'VOLLZEIT'
  | 'WERKSTUDENT';

export type Mitarbeiter_ArbeitsbereichStationDeleteMutationResponse = {
  __typename: 'mitarbeiter_arbeitsbereichStationDeleteMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_ArbeitsbereichStationDeleteSuccess>;
};

export type Mitarbeiter_ArbeitsbereichStationDeleteSuccess = {
  __typename: 'mitarbeiter_arbeitsbereichStationDeleteSuccess';
  arbeitsbereichStationId: Scalars['String']['output'];
  details: Scalars['String']['output'];
  fristResult?: Maybe<Mitarbeiter_DeleteArbeitsbereichStationFristResponse>;
  standortwechselResult?: Maybe<Mitarbeiter_DeleteArbeitsbereichStationStandortwechselResponse>;
};

export type Mitarbeiter_Arbeitsbereiche = {
  __typename: 'mitarbeiter_arbeitsbereiche';
  id: Scalars['String']['output'];
  markierung: Mitarbeiter_Markierung;
  name: Scalars['String']['output'];
  standort: Mitarbeiter_Standorte;
};

export type Mitarbeiter_BerechnungsartMonat =
  | 'DURCHSCHNITT'
  | 'EXAKT';

export type Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt =
  | 'Arbeitstage'
  | 'Sozialversicherungstage';

export type Mitarbeiter_Berufe = {
  __typename: 'mitarbeiter_berufe';
  abkuerzung?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  istAusbildung: Scalars['Boolean']['output'];
  markierung: Mitarbeiter_Markierung;
  name: Scalars['String']['output'];
};

export type Mitarbeiter_Bezahlungsart =
  | 'FixGehalt'
  | 'Stunden';

export type Mitarbeiter_CreateAbschnittInput = {
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  rotationsplanId: Scalars['String']['input'];
};

export type Mitarbeiter_CreateAbschnittMutationResponse = {
  __typename: 'mitarbeiter_createAbschnittMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_CreateAbschnittSuccess>;
};

export type Mitarbeiter_CreateAbschnittSuccess = {
  __typename: 'mitarbeiter_createAbschnittSuccess';
  abschnitt: Mitarbeiter_RotationsplanAbschnitt;
};

export type Mitarbeiter_CreateArbeitsbereichStationInput = {
  abschnittId: Scalars['String']['input'];
  abteilungsleiterId?: InputMaybe<Scalars['String']['input']>;
  arbeitsbereichId: Scalars['String']['input'];
  bis: Scalars['String']['input'];
  frist?: InputMaybe<Mitarbeiter_MitarbeiterCreateRotationsplanFristenInput>;
  lernziele: Scalars['String']['input'];
  rotationsplanId: Scalars['String']['input'];
  von: Scalars['String']['input'];
};

export type Mitarbeiter_CreateArbeitsbereichStationMutationResponse = {
  __typename: 'mitarbeiter_createArbeitsbereichStationMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_CreateArbeitsbereichStationSuccess>;
};

export type Mitarbeiter_CreateOrUpdateRotationsplanBewertungMutationResponse = {
  __typename: 'mitarbeiter_createOrUpdateRotationsplanBewertungMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_CreateOrUpdateRotationsplanBewertungSuccess>;
};

export type Mitarbeiter_CreateOrUpdateRotationsplanBewertungSuccess = {
  __typename: 'mitarbeiter_createOrUpdateRotationsplanBewertungSuccess';
  bewertung: Mitarbeiter_RotationsplanStationBewertung;
};

export type Mitarbeiter_CreateRotationsplanBewertungInput = {
  beurteilung: Scalars['String']['input'];
  stationId: Scalars['String']['input'];
  sterne: Scalars['Int']['input'];
};

export type Mitarbeiter_CreateRotationsplanInput = {
  berufId: Scalars['String']['input'];
  mitarbeiterId: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};

export type Mitarbeiter_DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type Mitarbeiter_DeleteRotationsplanBewertungMutationResponse = {
  __typename: 'mitarbeiter_deleteRotationsplanBewertungMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_DeleteRotationsplanBewertungSuccess>;
};

export type Mitarbeiter_DeleteRotationsplanBewertungSuccess = {
  __typename: 'mitarbeiter_deleteRotationsplanBewertungSuccess';
  bewertungId: Scalars['String']['output'];
  details: Scalars['String']['output'];
};

export type Mitarbeiter_DynamischeAbwesenheitsArt =
  | 'DREI_MONATSDURCHSCHNITT'
  | 'TAGESDURCHSCHNITT'
  | 'WOCHENDURCHSCHNITT'
  | 'ZWOELF_MONATSDURCHSCHNITT';

export type Mitarbeiter_EmailValidation = {
  __typename: 'mitarbeiter_emailValidation';
  findings: Array<FindingsUnion>;
};

export type Mitarbeiter_Erfahrungslevel =
  | 'ALTERHASE'
  | 'ANFAENGER'
  | 'FORTGESCHRITTENER'
  | 'KEINEBEWERTUNG';

export type Mitarbeiter_ExistiertPersonalnummerInAnderemStandort = {
  __typename: 'mitarbeiter_existiertPersonalnummerInAnderemStandort';
  existiertPersonalnummer: Scalars['Boolean']['output'];
};

export type Mitarbeiter_Manager = {
  __typename: 'mitarbeiter_manager';
  ausgeblendeteArbeitsbereichIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type Mitarbeiter_Markierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Mitarbeiter_Mitarbeiter = {
  __typename: 'mitarbeiter_mitarbeiter';
  arbeitnehmerTyp?: Maybe<Mitarbeiter_ArbeitnehmerTyp>;
  arbeitsbereich?: Maybe<Mitarbeiter_Arbeitsbereiche>;
  bildUrl?: Maybe<Scalars['String']['output']>;
  e2nId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  personalnummer: Scalars['String']['output'];
  standort: Mitarbeiter_Standorte;
  uid: Scalars['ID']['output'];
  vorname: Scalars['String']['output'];
};

export type Mitarbeiter_MitarbeiterCreateAbwesenheitenAllgemeinInput = {
  abwesenheitszeitBegrenzen?: InputMaybe<Scalars['Boolean']['input']>;
  anzahlArbeitstage?: InputMaybe<Mitarbeiter_AnzahlArbeitstage>;
  anzahlUrlaubstage?: InputMaybe<Scalars['Float']['input']>;
  berechnungsgrundlageDreiMonatsdurchschnitt?: InputMaybe<Mitarbeiter_BerechnungsgrundlageDreiMonatsdurchschnitt>;
  dynamischeAbwesenheitsArt?: InputMaybe<Mitarbeiter_DynamischeAbwesenheitsArt>;
  stunden?: InputMaybe<Scalars['Int']['input']>;
  stundenBewertung?: InputMaybe<Mitarbeiter_StundenBewertung>;
};

export type Mitarbeiter_MitarbeiterCreateAbwesenheitenInput = {
  allgemein?: InputMaybe<Mitarbeiter_MitarbeiterCreateAbwesenheitenAllgemeinInput>;
  guttage?: InputMaybe<Mitarbeiter_MitarbeiterCreateGuttageInput>;
};

export type Mitarbeiter_MitarbeiterCreateAnstellungInput = {
  anstellungstyp?: InputMaybe<Mitarbeiter_Anstellungstyp>;
  /** ISO-Datum im Format YYYY-MM-DD */
  befristung?: InputMaybe<Scalars['String']['input']>;
  /** ISO-Datum im Format YYYY-MM-DD */
  eintrittsdatum: Scalars['String']['input'];
};

export type Mitarbeiter_MitarbeiterCreateAnstellungsverhaeltnisInput = {
  anstellung: Mitarbeiter_MitarbeiterCreateAnstellungInput;
  fristen?: InputMaybe<Array<Mitarbeiter_MitarbeiterCreateFristenInput>>;
};

export type Mitarbeiter_MitarbeiterCreateArbeitsbereichInput = {
  erfahrungslevel?: InputMaybe<Mitarbeiter_Erfahrungslevel>;
  primaererArbeitsbereich: Scalars['String']['input'];
  sekundaereArbeitsbereiche?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Mitarbeiter_MitarbeiterCreateBezahlungInput = {
  bezahlungsart: Mitarbeiter_MitarbeiterCreateBezahlungsartInput;
  sollstunden?: InputMaybe<Mitarbeiter_MitarbeiterCreateSollstundenInput>;
  zuschlaege?: InputMaybe<Mitarbeiter_MitarbeiterCreateZuschlaegeInput>;
};

export type Mitarbeiter_MitarbeiterCreateBezahlungsartInput = {
  art: Mitarbeiter_Bezahlungsart;
  monatsgehalt?: InputMaybe<Scalars['Float']['input']>;
  stundenlohn?: InputMaybe<Scalars['Float']['input']>;
  tarifGruppeId?: InputMaybe<Scalars['String']['input']>;
};

export type Mitarbeiter_MitarbeiterCreateFristenInput = {
  bemerkung?: InputMaybe<Scalars['String']['input']>;
  erinnerungAn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ein Array von ISO-Datum im Format YYYY-MM-DD */
  erinnerungsZeit?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO-Datum im Format YYYY-MM-DD */
  fristdatum: Scalars['String']['input'];
  grund: Scalars['String']['input'];
};

export type Mitarbeiter_MitarbeiterCreateGuttageInput = {
  guttageBewerten?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mitarbeiter_MitarbeiterCreateInput = {
  abwesenheiten?: InputMaybe<Mitarbeiter_MitarbeiterCreateAbwesenheitenInput>;
  anstellungsverhaeltnis: Mitarbeiter_MitarbeiterCreateAnstellungsverhaeltnisInput;
  bezahlung: Mitarbeiter_MitarbeiterCreateBezahlungInput;
  person: Mitarbeiter_MitarbeiterCreatePersonInput;
  speicheroptionen: Mitarbeiter_MitarbeiterCreateSpeicheroptionenInput;
};

export type Mitarbeiter_MitarbeiterCreateKontaktInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  mobilnummer?: InputMaybe<Scalars['String']['input']>;
};

export type Mitarbeiter_MitarbeiterCreatePersoenlichesInput = {
  anrede: Mitarbeiter_Anrede;
  e2nId?: InputMaybe<Scalars['String']['input']>;
  nachname: Scalars['String']['input'];
  personalnummer?: InputMaybe<Scalars['String']['input']>;
  rufname?: InputMaybe<Scalars['String']['input']>;
  vorname: Scalars['String']['input'];
};

export type Mitarbeiter_MitarbeiterCreatePersonInput = {
  arbeitsbereiche: Mitarbeiter_MitarbeiterCreateArbeitsbereichInput;
  kontakt?: InputMaybe<Mitarbeiter_MitarbeiterCreateKontaktInput>;
  persoenliches: Mitarbeiter_MitarbeiterCreatePersoenlichesInput;
};

export type Mitarbeiter_MitarbeiterCreateRotationsplanFristenInput = {
  erinnerungAn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ein Array von ISO-Datum im Format YYYY-MM-DD */
  erinnerungsZeit?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Mitarbeiter_MitarbeiterCreateSollstundenInput = {
  arbeitstage?: InputMaybe<Array<Mitarbeiter_DayOfWeek>>;
  auszahlungsgrenze?: InputMaybe<Scalars['Boolean']['input']>;
  auszahlungsgrenzeBetrag?: InputMaybe<Scalars['Float']['input']>;
  auszahlungsgrenzeDauer?: InputMaybe<Scalars['Int']['input']>;
  berechnungsartMonat?: InputMaybe<Mitarbeiter_BerechnungsartMonat>;
  monatsstunden?: InputMaybe<Scalars['Int']['input']>;
  richtwert?: InputMaybe<Scalars['Boolean']['input']>;
  richtwertBetrag?: InputMaybe<Scalars['Float']['input']>;
  richtwertDauer?: InputMaybe<Scalars['Int']['input']>;
  sollstunden?: InputMaybe<Scalars['Boolean']['input']>;
  stundenpensum?: InputMaybe<Mitarbeiter_Stundenpensum>;
  tagessoll?: InputMaybe<Scalars['Int']['input']>;
  unbezahlteUeberstundenMonat?: InputMaybe<Scalars['Int']['input']>;
  unbezahlteUeberstundenWoche?: InputMaybe<Scalars['Int']['input']>;
  wochenstunden?: InputMaybe<Scalars['Int']['input']>;
};

export type Mitarbeiter_MitarbeiterCreateSpeicheroptionenInput = {
  personalfragebogen?: Scalars['Boolean']['input'];
  personalzugang?: Scalars['Boolean']['input'];
};

export type Mitarbeiter_MitarbeiterCreateZuschlaegeInput = {
  pauschaleZuschlaege?: InputMaybe<Scalars['Float']['input']>;
  uebertariflicheZahlung?: InputMaybe<Scalars['Float']['input']>;
  zuschlagsgruppe?: InputMaybe<Scalars['String']['input']>;
};

export type Mitarbeiter_MitarbeiterStatus =
  | 'AKTIV'
  | 'AKTIV_UND_ZUKUENFTIG'
  | 'ALLE'
  | 'INAKTIV';

export type Mitarbeiter_PersonalIdsResponse = {
  __typename: 'mitarbeiter_personalIdsResponse';
  e2nIdMitarbeiter: Array<Mitarbeiter_Mitarbeiter>;
  personalnummernMitarbeiter: Array<Mitarbeiter_Mitarbeiter>;
};

export type Mitarbeiter_Rotationsplan = {
  __typename: 'mitarbeiter_rotationsplan';
  abschnitte: Array<Mitarbeiter_RotationsplanAbschnitt>;
  abwesenheiten: Array<Mitarbeiter_RotationsplanAbwesenheit>;
  beruf: Mitarbeiter_Berufe;
  id: Scalars['String']['output'];
  land: Scalars['String']['output'];
  mitarbeiter: Mitarbeiter_Mitarbeiter;
  standortId: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanAbschnitt = {
  __typename: 'mitarbeiter_rotationsplanAbschnitt';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  stationen: Array<Mitarbeiter_RotationsplanStation>;
};

export type Mitarbeiter_RotationsplanAbschnittCreateManagerNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittCreateManagerNotFound';
  managerId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanAbschnittCreateRotationsplanNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittCreateRotationsplanNotFound';
  message: Scalars['String']['output'];
  rotationsplanId?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_RotationsplanAbschnittNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanAbschnittUpdateAbschnittNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittUpdateAbschnittNotFound';
  abschnittId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanAbschnittUpdateManagerNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittUpdateManagerNotFound';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanAbschnittUpdateRotationsplanNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanAbschnittUpdateRotationsplanNotFound';
  message: Scalars['String']['output'];
  rotationsplanId?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_RotationsplanAbwesenheit = {
  __typename: 'mitarbeiter_rotationsplanAbwesenheit';
  bis: Scalars['Date']['output'];
  faktor: Scalars['Float']['output'];
  grund: RotationsplanAbwesenheitsgruende;
  id: Scalars['String']['output'];
  von: Scalars['Date']['output'];
};

export type Mitarbeiter_RotationsplanAbwesenheitsStation = Mitarbeiter_RotationsplanStation & {
  __typename: 'mitarbeiter_rotationsplanAbwesenheitsStation';
  bis: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  von: Scalars['Date']['output'];
};

export type Mitarbeiter_RotationsplanArbeitsbereichNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanArbeitsbereichNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanArbeitsbereichStation = Mitarbeiter_RotationsplanStation & {
  __typename: 'mitarbeiter_rotationsplanArbeitsbereichStation';
  abteilungsleiter?: Maybe<Mitarbeiter_Abteilungsleiter>;
  arbeitsbereich: Mitarbeiter_Arbeitsbereiche;
  bewertung?: Maybe<Mitarbeiter_RotationsplanStationBewertung>;
  bis: Scalars['Date']['output'];
  frist?: Maybe<Mitarbeiter_Frist>;
  id: Scalars['String']['output'];
  lernziele: Scalars['String']['output'];
  standortwechselId?: Maybe<Scalars['String']['output']>;
  von: Scalars['Date']['output'];
};

export type Mitarbeiter_RotationsplanArbeitsbereichStationNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanArbeitsbereichStationNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanBereichsleiterNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanBereichsleiterNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanBewertungAlreadyExists = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanBewertungAlreadyExists';
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanBewertungNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanBewertungNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanDeleteMutationResponse = {
  __typename: 'mitarbeiter_rotationsplanDeleteMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_RotationsplanDeleteSuccess>;
};

export type Mitarbeiter_RotationsplanDeleteSuccess = {
  __typename: 'mitarbeiter_rotationsplanDeleteSuccess';
  details: Scalars['String']['output'];
  rotationsplanId: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanEinstellungen = {
  __typename: 'mitarbeiter_rotationsplanEinstellungen';
  istRotationsplanAktiviert: Scalars['Boolean']['output'];
};

export type Mitarbeiter_RotationsplanEndeVorBeginn = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanEndeVorBeginn';
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanError = {
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanFristKonnteNichtErstelltWerden = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanFristKonnteNichtErstelltWerden';
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanManagerNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanManagerNotFound';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mitarbeiter_RotationsplanStandortwechselKonnteNichtErstelltWerden = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanStandortwechselKonnteNichtErstelltWerden';
  message: Scalars['String']['output'];
  standortId?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_RotationsplanStandortwechselKonnteNichtGeloeschtWerden = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanStandortwechselKonnteNichtGeloeschtWerden';
  message: Scalars['String']['output'];
  standortwechselId?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_RotationsplanStation = {
  bis: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  von: Scalars['Date']['output'];
};

export type Mitarbeiter_RotationsplanStationBewertung = {
  __typename: 'mitarbeiter_rotationsplanStationBewertung';
  beurteilung: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sterne: Scalars['Int']['output'];
};

export type Mitarbeiter_RotationsplanStationNotFound = Mitarbeiter_RotationsplanError & {
  __typename: 'mitarbeiter_rotationsplanStationNotFound';
  message: Scalars['String']['output'];
  stationId?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_Standorte = {
  __typename: 'mitarbeiter_standorte';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storenummer: Scalars['String']['output'];
  tarifvertrag?: Maybe<Mitarbeiter_Tarifvertrag>;
};


export type Mitarbeiter_StandorteTarifvertragArgs = {
  gueltigAb?: InputMaybe<Scalars['String']['input']>;
};

export type Mitarbeiter_Standortgruppen = {
  __typename: 'mitarbeiter_standortgruppen';
  berufe: Array<Mitarbeiter_Berufe>;
  id: Scalars['String']['output'];
  rotationsplanEinstellungen?: Maybe<Mitarbeiter_RotationsplanEinstellungen>;
  standorte: Array<Mitarbeiter_Standortgruppen_Standorte>;
};

export type Mitarbeiter_Standortgruppen_Standorte = {
  __typename: 'mitarbeiter_standortgruppen_standorte';
  id: Scalars['String']['output'];
  land: Scalars['String']['output'];
  name: Scalars['String']['output'];
  storenummer?: Maybe<Scalars['String']['output']>;
};

export type Mitarbeiter_StundenBewertung =
  | 'dynamisch'
  | 'fest';

export type Mitarbeiter_Stundenpensum =
  | 'MONAT'
  | 'WOCHE';

export type Mitarbeiter_Tarifgruppen = {
  __typename: 'mitarbeiter_tarifgruppen';
  gehalt: Scalars['Float']['output'];
  gruppe: Scalars['Int']['output'];
  gueltigAb: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  stundenlohn: Scalars['Float']['output'];
};

export type Mitarbeiter_Tarifvertrag = {
  __typename: 'mitarbeiter_tarifvertrag';
  id: Scalars['String']['output'];
  tarifgruppen: Array<Mitarbeiter_Tarifgruppen>;
  tarifvertragTyp: Mitarbeiter_Tarifvertragtyp;
};

export type Mitarbeiter_Tarifvertragtyp =
  | 'BAECKEREI_WOLF'
  | 'MANTEL_BACK_BY'
  | 'MANTEL_BACK_NRW'
  | 'MANTEL_BACK_SH'
  | 'MANTEL_SYSGASTRO_BDS';

export type Mitarbeiter_UpdateArbeitsbereichStationInput = {
  abschnittId: Scalars['String']['input'];
  abteilungsleiterId?: InputMaybe<Scalars['String']['input']>;
  arbeitsbereichId: Scalars['String']['input'];
  bis: Scalars['String']['input'];
  frist?: InputMaybe<Mitarbeiter_MitarbeiterCreateRotationsplanFristenInput>;
  lernziele: Scalars['String']['input'];
  rotationsplanId: Scalars['String']['input'];
  standortwechselId?: InputMaybe<Scalars['String']['input']>;
  stationId: Scalars['String']['input'];
  von: Scalars['String']['input'];
};

export type Mitarbeiter_UpdateArbeitsbereichStationMutationResponse = {
  __typename: 'mitarbeiter_updateArbeitsbereichStationMutationResponse';
  error?: Maybe<Mitarbeiter_RotationsplanError>;
  success?: Maybe<Mitarbeiter_UpdateArbeitsbereichStationSuccess>;
};

export type Mitarbeiter_UpdateArbeitsbereichStationSuccessFristenResultUnion = Mitarbeiter_CreateOrUpdateArbeitsbereichStationFristResponse | Mitarbeiter_DeleteArbeitsbereichStationFristResponse;

export type Mitarbeiter_UpdateRotationsplanBewertungInput = {
  beurteilung: Scalars['String']['input'];
  id: Scalars['String']['input'];
  stationId: Scalars['String']['input'];
  sterne: Scalars['Int']['input'];
};

export type Navigation_Arbeitsbereich = {
  __typename: 'navigation_Arbeitsbereich';
  id?: Maybe<Scalars['String']['output']>;
  markierung: Navigation_Arbeitsbereich_Markierung;
  name: Scalars['String']['output'];
};

export type Navigation_Arbeitsbereich_Markierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Navigation_Error = {
  message: Scalars['String']['output'];
};

export type Navigation_GeneralError = Navigation_Error & {
  __typename: 'navigation_GeneralError';
  message: Scalars['String']['output'];
};

export type Navigation_ManagerNotFound = Navigation_Error & {
  __typename: 'navigation_ManagerNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_Mitarbeiter = {
  __typename: 'navigation_Mitarbeiter';
  bildUrl?: Maybe<Scalars['String']['output']>;
  extern: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  personalnummer?: Maybe<Scalars['String']['output']>;
  standort: Scalars['String']['output'];
  type: Navigation_MitarbeiterType;
  vorname: Scalars['String']['output'];
};

export type Navigation_MitarbeiterType =
  | 'ACTIVE'
  | 'INACTIVE';

export type Navigation_NewsItemNotFound = Navigation_Error & {
  __typename: 'navigation_NewsItemNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_NewsUpdateMutationResponse = {
  __typename: 'navigation_NewsUpdateMutationResponse';
  error?: Maybe<Manager_Error>;
  newsItem?: Maybe<Navigation_News>;
};

export type Navigation_SchichttauschantraegeUpdateMutationResponse = {
  __typename: 'navigation_SchichttauschantraegeUpdateMutationResponse';
  error?: Maybe<Navigation_Error>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Navigation_SchichttauschantragUpdateManagerNotFound = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateManagerNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_SchichttauschantragUpdateSchichttauschAntragNotFound = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateSchichttauschAntragNotFound';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_SchichttauschantragUpdateSettingNotActivated = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateSettingNotActivated';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_SchichttauschantragUpdateStatusNotSupported = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateStatusNotSupported';
  message: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type Navigation_SchichttauschantragUpdateTauschpartnerIllegal = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateTauschpartnerIllegal';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_SchichttauschantragUpdateTauschpartnerMissing = Navigation_Error & {
  __typename: 'navigation_SchichttauschantragUpdateTauschpartnerMissing';
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Navigation_SearchResult = Navigation_Mitarbeiter | Navigation_Standort;

export type Navigation_Standort = {
  __typename: 'navigation_Standort';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Navigation_Abwesenheitsgrund =
  | 'ARBEITSUNFALL'
  | 'ARZTBESUCH'
  | 'AUSGLEICHSRUHEZEITENTAG'
  | 'BESCHAEFTIGUNGSVERBOT'
  | 'BEZAHLTERARBEITSFREIERTAG'
  | 'BILDUNG'
  | 'ELTERNZEIT'
  | 'EURENTE'
  | 'FEHLTUNENTSCHULDIGT'
  | 'FEIERTAG'
  | 'FEIERTAGSAUSGLEICH'
  | 'FEIERTAGSAUSGLEICHDYNAMISCH'
  | 'FERIENTAG'
  | 'FREI'
  | 'FREISTELLUNG'
  | 'GUTTAGMINUS'
  | 'GUTTAGPLUS'
  | 'KOMPENSATIONSTAG'
  | 'KRANK'
  | 'KRANKENGELD'
  | 'KRANKESKIND'
  | 'KRANKIMFREI'
  | 'KRANKINKURZARBEIT'
  | 'KRANKOHNELOHNFORTZAHLUNG'
  | 'KUR'
  | 'KURZARBEIT'
  | 'LEHRGANG'
  | 'MILITAERZIVILDIENST'
  | 'MUTTERSCHAFT'
  | 'MUTTERSCHUTZ'
  | 'QUARANTAENE'
  | 'QUARANTAENEOHNELFZ'
  | 'RUHETAG'
  | 'SCHULE'
  | 'SONDERURLAUB'
  | 'UEBERSTUNDENABBAU'
  | 'UNBEZAHLTERFERIENTAG'
  | 'UNBEZAHLTERURLAUB'
  | 'UNFALL'
  | 'URLAUB'
  | 'VATERSCHAFT'
  | 'WIEDEREINGLIEDERUNG'
  | 'WUNSCHFREI';

export type Navigation_ArbeitszeitBenachrichtigung = {
  __typename: 'navigation_arbeitszeitBenachrichtigung';
  arbeitsbereich: Navigation_Arbeitsbereich;
  datum: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
  status: Scalars['String']['output'];
};

export type Navigation_Benachrichtigungen = {
  __typename: 'navigation_benachrichtigungen';
  abwesenheitsantraege?: Maybe<Array<Abwesenheitsantrag>>;
  /** @deprecated Ersetzt durch das Feld `fehlendeArbeitszeiten` */
  arbeitsbereich?: Maybe<Navigation_Arbeitsbereich>;
  /** @deprecated Ersetzt durch das Feld `fehlendeArbeitszeiten` */
  datum?: Maybe<Scalars['String']['output']>;
  dokumente?: Maybe<Array<Navigation_Dokumente>>;
  /** Ersetzt die anderen Felder um Benachrichtigungen für fehlende Arbeitszeiten abzufragen */
  fehlendeArbeitszeit?: Maybe<Array<Navigation_ArbeitszeitBenachrichtigung>>;
  fristen?: Maybe<Array<Navigation_Fristen>>;
  /** @deprecated Ersetzt durch das Feld `fehlendeArbeitszeiten` */
  id?: Maybe<Scalars['String']['output']>;
  krankmeldungen?: Maybe<Array<Navigation_Krankmeldungen>>;
  /** @deprecated Ersetzt durch das Feld `fehlendeArbeitszeiten` */
  mitarbeiter?: Maybe<Navigation_Mitarbeiter2>;
  mitarbeiterantraege?: Maybe<Array<Personalfragebogen>>;
  schichttauschantraege?: Maybe<Array<Navigation_Schichttauschantraege>>;
  /** @deprecated Ersetzt durch das Feld `fehlendeArbeitszeiten` */
  status?: Maybe<Scalars['String']['output']>;
};

export type Navigation_Dokumente = {
  __typename: 'navigation_dokumente';
  erstellungsDatum: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
  name: Scalars['String']['output'];
};

export type Navigation_Fristen = {
  __typename: 'navigation_fristen';
  ablaufZeitpunkt: Scalars['Date']['output'];
  gelesen: Scalars['Boolean']['output'];
  grund: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
};

export type Navigation_GenericError = {
  __typename: 'navigation_genericError';
  message: Scalars['String']['output'];
};

export type Navigation_Krankmeldungen = {
  __typename: 'navigation_krankmeldungen';
  istKindkrank: Scalars['Boolean']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
  voraussichtlichBis: Scalars['Date']['output'];
  voraussichtlichVon: Scalars['Date']['output'];
};

export type Navigation_Manager = {
  __typename: 'navigation_manager';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  news: Array<Navigation_News>;
};

export type Navigation_ManagerResult = Navigation_GenericError | Navigation_Manager;

export type Navigation_Markierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Navigation_Mitarbeiter2 = {
  __typename: 'navigation_mitarbeiter2';
  arbeitnehmertyp?: Maybe<Scalars['String']['output']>;
  arbeitsbereich: Navigation_Arbeitsbereich;
  bildUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  istExtern: Scalars['Boolean']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type Navigation_News = {
  __typename: 'navigation_news';
  bildUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inhalt: Scalars['String']['output'];
  istGelesen: Scalars['Boolean']['output'];
  titel: Scalars['String']['output'];
  veroeffentlichtAm: Scalars['Date']['output'];
};

export type Navigation_Schicht = {
  __typename: 'navigation_schicht';
  arbeitsbereich: Navigation_Arbeitsbereich;
  beginn: Scalars['Date']['output'];
  ende: Scalars['Date']['output'];
  id: Scalars['String']['output'];
};

export type Navigation_Schichttauschantraege = {
  __typename: 'navigation_schichttauschantraege';
  bemerkungAntragsteller: Scalars['String']['output'];
  erstellungsDatum: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  mitarbeiter: Navigation_Mitarbeiter2;
  schicht: Navigation_Schicht;
  status: Navigation_SchichttauschantragStatus;
};

export type Navigation_SchichttauschantragStatus =
  | 'ABGEBROCHEN'
  | 'ABGELAUFEN'
  | 'ABGELEHNT'
  | 'ANFRAGE'
  | 'GELOESCHT'
  | 'GENEHMIGT'
  | 'NEU'
  | 'RUECKFRAGE';

export type Navigation_Standortgruppen = {
  __typename: 'navigation_standortgruppen';
  id: Scalars['String']['output'];
  istAnalyticsEnabled: Scalars['Boolean']['output'];
  istRotationsplanAktiviert: Scalars['Boolean']['output'];
};

export type Navigation_UpdateFristGelesenInput = {
  id: Scalars['String']['input'];
  istGelesen: Scalars['Boolean']['input'];
};

export type Navigation_UpdateSchichttauschInput = {
  bemerkungManager: Scalars['String']['input'];
  schichttauschAntragId: Scalars['String']['input'];
  status: Navigation_SchichttauschantragStatus;
  tauschPartnerId?: InputMaybe<Scalars['String']['input']>;
};

export type Personalzugang_CreateResponse = {
  __typename: 'personalzugang_CreateResponse';
  error?: Maybe<Personalzugang_Error>;
  success: Scalars['Boolean']['output'];
};

export type Personalzugang_Error = Mitarbeiter_MitarbeiterAbstractError & {
  __typename: 'personalzugang_Error';
  errorCode: Personalzugang_ErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export type Root = ToDosAbwesenheiten | ToDosArbeitszeiten;

export type Termin_IndividuelleWiederholung = {
  __typename: 'termin_IndividuelleWiederholung';
  occurrenceCount: Scalars['Int']['output'];
  weekDayOccurrence?: Maybe<Termin_WeekdayOccurrence>;
  wiederholungsIntervall: Termin_WiederholungsIntervall;
  wochentage: Array<Termin_Wochentage>;
};

export type Termin_WeekdayOccurrence =
  | 'DRITTER'
  | 'ERSTER'
  | 'FIXER_TAG'
  | 'LETZTER'
  | 'VIERTER'
  | 'ZWEITER';

export type Termin_Wiederholung =
  | 'INDIVIDUELL'
  | 'JAEHRLICH'
  | 'MONATLICH'
  | 'OHNE'
  | 'TAEGLICH'
  | 'WOECHENTLICH';

export type Termin_WiederholungsIntervall =
  | 'JAHR'
  | 'MONAT'
  | 'TAG'
  | 'WOCHE';

export type Termin_Wochentage =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type Termine_Mitarbeiter = {
  __typename: 'termine_Mitarbeiter';
  bildUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  nachname: Scalars['String']['output'];
  vorname: Scalars['String']['output'];
};

export type Termine_Arbeitsbereich = {
  __typename: 'termine_arbeitsbereich';
  id: Scalars['String']['output'];
  markierung: Termine_ArbeitsbereichMarkierung;
  name: Scalars['String']['output'];
};

export type Termine_ArbeitsbereichMarkierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Termine_Arbeitszeiten = {
  __typename: 'termine_arbeitszeiten';
  arbeitsbereich: Termine_Arbeitsbereich;
  beginn?: Maybe<Scalars['String']['output']>;
  datum: Scalars['String']['output'];
  ende?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mitarbeiter: Termine_Mitarbeiter;
};

export type Termine_DeleteArbeitszeitVerknuepfung = {
  __typename: 'termine_deleteArbeitszeitVerknuepfung';
  error?: Maybe<Termine_TermineError>;
  result?: Maybe<Termine_DeleteArbeitszeitVerknuepfungSuccess>;
};

export type Termine_DeleteArbeitszeitVerknuepfungSuccess = {
  __typename: 'termine_deleteArbeitszeitVerknuepfungSuccess';
  success: Scalars['Boolean']['output'];
};

export type Termine_DeleteKalender = {
  idTargetTerminkalender?: InputMaybe<Scalars['String']['input']>;
  idTerminkalender: Scalars['String']['input'];
};

export type Termine_DeleteSchichtVerknuepfung = {
  __typename: 'termine_deleteSchichtVerknuepfung';
  error?: Maybe<Termine_TermineError>;
  result?: Maybe<Termine_DeleteSchichtVerknuepfungSuccess>;
};

export type Termine_DeleteSchichtVerknuepfungSuccess = {
  __typename: 'termine_deleteSchichtVerknuepfungSuccess';
  idSchichten: Array<Scalars['String']['output']>;
  idTerminDefinition: Scalars['String']['output'];
};

export type Termine_DesignAuswahl =
  | 'V1'
  | 'V2';

export type Termine_Details = {
  __typename: 'termine_details';
  beschreibung?: Maybe<Scalars['String']['output']>;
  specials?: Maybe<Scalars['String']['output']>;
};

export type Termine_Dokumente = {
  __typename: 'termine_dokumente';
  haengtAm?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Termine_Feiertag = {
  __typename: 'termine_feiertag';
  datum: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Termine_GeneralError = Termine_TermineError & {
  __typename: 'termine_generalError';
  message: Scalars['String']['output'];
};

export type Termine_Image = {
  __typename: 'termine_image';
  contentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Termine_IndividuelleWiederholungInput = {
  occurrenceCount: Scalars['Int']['input'];
  weekDayOccurrence?: InputMaybe<Termin_WeekdayOccurrence>;
  wiederholungsIntervall: Termin_WiederholungsIntervall;
  wochentage: Array<Termin_Wochentage>;
};

export type Termine_IndividuelleWiederholungUpdateInput = {
  occurrenceCount: Scalars['Int']['input'];
  weekDayOccurrence?: InputMaybe<Termin_WeekdayOccurrence>;
  wiederholungsIntervall: Termin_WiederholungsIntervall;
  wochentage: Array<Termin_Wochentage>;
};

export type Termine_Kalender = {
  __typename: 'termine_kalender';
  id: Scalars['ID']['output'];
  idStandort: Scalars['String']['output'];
  kalenderSchluessel: Scalars['Float']['output'];
  markierung: Termine_KalenderMarkierung;
  name: Scalars['String']['output'];
  termine: Array<Termine_Termine>;
};

export type Termine_KalenderDeleteError = {
  __typename: 'termine_kalenderDeleteError';
  details?: Maybe<Scalars['String']['output']>;
};

export type Termine_KalenderDeleteSuccess = {
  __typename: 'termine_kalenderDeleteSuccess';
  idTargetTerminkalender?: Maybe<Scalars['String']['output']>;
  idTerminkalender?: Maybe<Scalars['String']['output']>;
};

export type Termine_KalenderGeneralError = Termine_TerminKalenderError & {
  __typename: 'termine_kalenderGeneralError';
  message: Scalars['String']['output'];
};

export type Termine_KalenderMarkierung =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CYAN'
  | 'DARKBLUE'
  | 'DARKGREEN'
  | 'DARKRED'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'LIGHTBLUE'
  | 'LIGHTGRAY'
  | 'LIGHTGREEN'
  | 'LILA'
  | 'MAGENTA'
  | 'ORANGE'
  | 'PINK'
  | 'RED'
  | 'ROSE'
  | 'VIOLETT'
  | 'YELLOW';

export type Termine_KalenderValidationError = Termine_TerminKalenderError & {
  __typename: 'termine_kalenderValidationError';
  message: Scalars['String']['output'];
};

export type Termine_ManagerDesignSettingsGeneralError = Termine_ManagerDesignSettingsUpdateError & {
  __typename: 'termine_managerDesignSettingsGeneralError';
  message: Scalars['String']['output'];
};

export type Termine_ManagerDesignSettingsUpdateError = {
  message: Scalars['String']['output'];
};

export type Termine_ManagerDesignSettingsUpdateInput = {
  designAuswahl?: InputMaybe<Termine_DesignAuswahl>;
  idManager?: InputMaybe<Scalars['String']['input']>;
  seiten?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Termine_ManagerDesignSettingsUpdateResponse = {
  __typename: 'termine_managerDesignSettingsUpdateResponse';
  error?: Maybe<Termine_ManagerDesignSettingsUpdateError>;
  result?: Maybe<Termine_ManagerDesignUpdateSuccess>;
};

export type Termine_ManagerDesignSettingsValidationError = Termine_ManagerDesignSettingsUpdateError & {
  __typename: 'termine_managerDesignSettingsValidationError';
  message: Scalars['String']['output'];
};

export type Termine_ManagerDesignUpdateSuccess = {
  __typename: 'termine_managerDesignUpdateSuccess';
  details: Scalars['String']['output'];
};

export type Termine_ManagerResult = TermineManager | TermineManagerError;

export type Termine_ManagerUpdateDesignSettingsManagerNotFoundError = Termine_ManagerDesignSettingsUpdateError & {
  __typename: 'termine_managerUpdateDesignSettingsManagerNotFoundError';
  message: Scalars['String']['output'];
};

export type Termine_ManagerUpdateDesignSettingsSeitennameTooLong = Termine_ManagerDesignSettingsUpdateError & {
  __typename: 'termine_managerUpdateDesignSettingsSeitennameTooLong';
  message: Scalars['String']['output'];
};

export type Termine_MitarbeiterLoadError = Termine_TermineError & {
  __typename: 'termine_mitarbeiterLoadError';
  message: Scalars['String']['output'];
};

export type Termine_Schichten = {
  __typename: 'termine_schichten';
  beginn?: Maybe<Scalars['String']['output']>;
  datum: Scalars['String']['output'];
  ende?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  markierung: SchichtenMarkierung;
  name: Scalars['String']['output'];
  termine_arbeitsbereich: Termine_Arbeitsbereich;
  termine_mitarbeiter: Array<Termine_Mitarbeiter>;
};

export type Termine_SchichtenLoadError = Termine_TermineError & {
  __typename: 'termine_schichtenLoadError';
  message: Scalars['String']['output'];
};

export type Termine_TerminCreateInput = {
  beginn?: InputMaybe<Scalars['String']['input']>;
  beschreibung?: InputMaybe<Scalars['String']['input']>;
  datum: Scalars['String']['input'];
  ende?: InputMaybe<Scalars['String']['input']>;
  individuelleWiederholung?: InputMaybe<Termine_IndividuelleWiederholungInput>;
  markierung: Markierung;
  specials?: InputMaybe<Scalars['String']['input']>;
  standortId: Scalars['String']['input'];
  terminImage?: InputMaybe<Termine_TerminImageInput>;
  terminKalenderId?: InputMaybe<Scalars['String']['input']>;
  titel: Scalars['String']['input'];
  wiederholung: Termin_Wiederholung;
  wiederholungBis?: InputMaybe<Scalars['String']['input']>;
};

export type Termine_TerminCreateResponse = {
  __typename: 'termine_terminCreateResponse';
  error?: Maybe<Termine_TermineError>;
  result?: Maybe<Termine_Termine>;
};

export type Termine_TerminDeleteArbeitszeitenVerknuepfungExistError = Termine_TermineError & {
  __typename: 'termine_terminDeleteArbeitszeitenVerknuepfungExistError';
  message: Scalars['String']['output'];
};

export type Termine_TerminDeleteImageDeleteFailureError = Termine_TermineError & {
  __typename: 'termine_terminDeleteImageDeleteFailureError';
  message: Scalars['String']['output'];
};

export type Termine_TerminDeleteManagerNotFoundError = Termine_TermineError & {
  __typename: 'termine_terminDeleteManagerNotFoundError';
  managerId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Termine_TerminDeleteResponse = {
  __typename: 'termine_terminDeleteResponse';
  error?: Maybe<Termine_TermineError>;
  result?: Maybe<Termine_TerminDeleteSuccess>;
};

export type Termine_TerminDeleteSchichtenVerknuepfungExistError = Termine_TermineError & {
  __typename: 'termine_terminDeleteSchichtenVerknuepfungExistError';
  message: Scalars['String']['output'];
};

export type Termine_TerminDeleteSuccess = {
  __typename: 'termine_terminDeleteSuccess';
  terminId: Scalars['String']['output'];
};

export type Termine_TerminDeleteTerminDefinitionNotFoundError = Termine_TermineError & {
  __typename: 'termine_terminDeleteTerminDefinitionNotFoundError';
  idTermin: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Termine_TerminImageInput = {
  base64Image: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Termine_TerminImageUpdateInput = {
  base64Image?: InputMaybe<Scalars['String']['input']>;
  idStandort?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Termine_TerminKalenderCreateInput = {
  markierung: Markierung;
  name: Scalars['String']['input'];
  standortId: Scalars['String']['input'];
};

export type Termine_TerminKalenderCreateResponse = {
  __typename: 'termine_terminKalenderCreateResponse';
  error?: Maybe<Termine_TerminKalenderError>;
  result?: Maybe<Termine_Kalender>;
};

export type Termine_TerminKalenderDeleteResponse = {
  __typename: 'termine_terminKalenderDeleteResponse';
  error?: Maybe<Termine_KalenderDeleteError>;
  result?: Maybe<Termine_KalenderDeleteSuccess>;
};

export type Termine_TerminKalenderError = {
  message: Scalars['String']['output'];
};

export type Termine_TerminUpdateInput = {
  beginn?: InputMaybe<Scalars['String']['input']>;
  beschreibung?: InputMaybe<Scalars['String']['input']>;
  datum: Scalars['String']['input'];
  ende?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  individuelleWiederholung?: InputMaybe<Termine_IndividuelleWiederholungUpdateInput>;
  markierung: Markierung;
  specials?: InputMaybe<Scalars['String']['input']>;
  terminImage?: InputMaybe<Termine_TerminImageUpdateInput>;
  terminKalenderId?: InputMaybe<Scalars['String']['input']>;
  titel: Scalars['String']['input'];
  wiederholung: Termin_Wiederholung;
  wiederholungBis?: InputMaybe<Scalars['String']['input']>;
};

export type Termine_TerminUpdateResponse = {
  __typename: 'termine_terminUpdateResponse';
  error?: Maybe<Termine_TermineError>;
  result?: Maybe<Termine_Termine>;
};

export type Termine_Termine = {
  __typename: 'termine_termine';
  beginn?: Maybe<Scalars['String']['output']>;
  datum: Scalars['String']['output'];
  dokumente?: Maybe<Array<Termine_Dokumente>>;
  ende?: Maybe<Scalars['String']['output']>;
  hasHiddenArbeitszeiten?: Maybe<Scalars['Boolean']['output']>;
  hasHiddenSchichten?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Termine_Image>;
  individuelleWiederholung?: Maybe<Termin_IndividuelleWiederholung>;
  markierung: Markierung;
  standortId: Scalars['String']['output'];
  terminKalenderId?: Maybe<Scalars['String']['output']>;
  termineDetails?: Maybe<Termine_Details>;
  termine_arbeitszeiten: Array<Termine_Arbeitszeiten>;
  termine_schichten: Array<Termine_Schichten>;
  titel: Scalars['String']['output'];
  wiederholung: Termin_Wiederholung;
  wiederholungBis?: Maybe<Scalars['String']['output']>;
};

export type Termine_TermineError = {
  message: Scalars['String']['output'];
};

export type Termine_TerminkalenderUpdateResponse = {
  __typename: 'termine_terminkalenderUpdateResponse';
  error?: Maybe<Termine_TerminKalenderError>;
  result?: Maybe<Termine_Kalender>;
};

export type Termine_UpdateKalender = {
  idTerminkalender: Scalars['String']['input'];
  markierung: Markierung;
  name: Scalars['String']['input'];
};

export type Termine_ValidationError = Termine_TermineError & {
  __typename: 'termine_validationError';
  message: Scalars['String']['output'];
};

export type Vertraege_Kuendigen = {
  beschreibung: Scalars['String']['input'];
  grund: Vertraege_KuendigungsGrund;
  kuendigungVersendetAm: Scalars['Date']['input'];
  kuendigungZum: Scalars['Date']['input'];
  kundennummer: Scalars['String']['input'];
  nachname: Scalars['String']['input'];
  telefon: Scalars['String']['input'];
  unternehmen: Scalars['String']['input'];
  vertragsId: Scalars['String']['input'];
  vorname: Scalars['String']['input'];
};

export type Vertraege_KuendigungFailure = {
  __typename: 'vertraege_kuendigungFailure';
  detail?: Maybe<Scalars['String']['output']>;
  errorCode: Vertraege_KuendigungErrorCode;
};

export type Vertraege_KuendigungSuccess = {
  __typename: 'vertraege_kuendigungSuccess';
  emailSent: Scalars['Boolean']['output'];
  vertrag: Vertrag;
};

export type Vertraege_KuendigungsGrund =
  | 'FEHLENDER_SUPPORT'
  | 'FEHLENDE_FUNKTION'
  | 'GESCHAEFTSAUFGABE'
  | 'INHABERWECHSEL'
  | 'INSOLVENZ'
  | 'KOSTEN'
  | 'MANGELHAFTES_ONBOARDING'
  | 'MARKTBEGLEITER'
  | 'ZEIT';

export type Vertraege_Upgrade = {
  beschreibung: Scalars['String']['input'];
  kontingent: Scalars['Float']['input'];
  kundennummer: Scalars['String']['input'];
  nachname: Scalars['String']['input'];
  preis: Scalars['String']['input'];
  telefon: Scalars['String']['input'];
  unternehmen: Scalars['String']['input'];
  upgradeVersendetAm: Scalars['Date']['input'];
  upgradeZum?: InputMaybe<Scalars['Date']['input']>;
  vertragId: Scalars['String']['input'];
  vorname: Scalars['String']['input'];
};

export type GetStandorteForManagerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStandorteForManagerQuery = { __typename: 'Query', manager:
    | { __typename: 'Manager', standorte: Array<{ __typename: 'Standort', uid: string, name: string, storeNummer?: string | null, lohnabrechnungseinstellungen: { __typename: 'Lohnabrechnungseinstellungen', beraternummer?: string | null, mandantennummer?: string | null, lohnabrechnungsart?: Standort_Lohnabrechnungsart | null } }> }
    | { __typename: 'ManagerError', message: string, type: string }
   };


export const GetStandorteForManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStandorteForManager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Manager"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"standorte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"storeNummer"}},{"kind":"Field","name":{"kind":"Name","value":"lohnabrechnungseinstellungen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beraternummer"}},{"kind":"Field","name":{"kind":"Name","value":"mandantennummer"}},{"kind":"Field","name":{"kind":"Name","value":"lohnabrechnungsart"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManagerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetStandorteForManagerQuery, GetStandorteForManagerQueryVariables>;